import "./AllEntity.scss";
import AllFiles from "../../../components/allFiles/AllFiles";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomButtonSmallDarkBg, CustomLoadingButton } from "../../../components/ui/CustomButton";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import app from "../../../utils/firebase";
import { showToast } from "../../../toastService.js";
import Big from "big.js";
import newRequest from "../../../utils/newRequest";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Menu,
  MenuItem,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useRef, useState } from "react";
import { FaSave } from "react-icons/fa";
import AddIcon from "@mui/icons-material/Add";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { IoCheckmarkDoneOutline, IoClose, IoDocumentTextSharp, IoLocationSharp } from "react-icons/io5";
import { MdAdd, MdAlternateEmail, MdClose, MdDelete, MdEdit, MdEmail, MdNumbers, MdOutlineMenuOpen, MdPhone } from "react-icons/md";
import { TbGenderEpicene } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { ScaleLoader } from "react-spinners";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import {
  fetchClientsBySearch,
  fetchMainLedgers,
  fetchSystemCodes,
  formatAmountsToDecimals,
  formatStringToNumberV2,
  getFirstName,
  handleOpenMap,
  sanitizeText,
  isValidMobileNumber,
  normalizePhoneNumber,
  generateUniqueCode,
  validateMandatoryDocuments,
  logData
} from "../../../utils/genericFunctions.js";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import { CiImageOn } from "react-icons/ci";
import { RiCheckFill, RiMenu5Line } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import GooglePlacesSelect from "../../../components/googlePlacesSelect/GooglePlacesSelect.jsx";
import UploadDialog from "../../../components/uploadDialog/UploadDialog.jsx";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import { RiMapPin5Fill } from "react-icons/ri";
import AllEntityCharge from "../allEntityCharge/AllEntityCharge.jsx";


const AllEntity = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);

  const [uploadTarget, setUploadTarget] = useState("firebase");

  const location = useLocation();
  const navigate = useNavigate();

  const [uploadProgress, setUploadProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [additionalActionsMenu, setAdditionalActionsMenu] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [currentAction, setCurrentAction] = useState("");
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [placesDialogOpen, setPlacesDialogOpen] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [entityData, setEntityData] = useState({});
  const [entityTraceData, setEntityTraceData] = useState([]);
  const [entCode, setEntCode] = useState(null);
  const [entAentCode, setEntAentCode] = useState(null);
  const [entName, setEntName] = useState(null);
  const [entAlias, setEntAlias] = useState(null);
  const [entType, setEntType] = useState(null);
  const [entStatus, setEntStatus] = useState(null);
  const [entSurname, setEntSurname] = useState(null);
  const [entOtherNames, setEntOtherNames] = useState(null);
  const [entIdNo, setEntIdNo] = useState(null);
  const [entGender, setEntGender] = useState(null);
  const [entDob, setEntDob] = useState(null);
  const [entAgeXx, setEntAgeXx] = useState(null);
  const [entTaxNo, setEntTaxNo] = useState(null);
  const [entLicenseNo, setEntLicenseNo] = useState(null);
  const [entPhoneNo, setEntPhoneNo] = useState(null);
  const [entEmail, setEntEmail] = useState(null);
  const [entPhotoUrl, setEntPhotoUrl] = useState(null);
  const [entPhysicalAddress, setEntPhysicalAddress] = useState(null);
  const [entPostalAddress, setEntPostalAddress] = useState(null);
  const [profileLimitValues, setProfileLimitValues] = useState([]);
  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [saveEnabled, setSaveEnabled] = useState("Y");
  const [nextAction, setNextAction] = useState("Activate");
  const [entOccupation, setEntOccupation] = useState(null);
  const [smokingFlags, setSmokingFlags] = useState([]);
  const [entSmokeFlag, setEntSmokeFlag] = useState(null);
  const [entLedgers, setEntLedgers] = useState([]);
  const [entRatings, setEntRatings] = useState([]);
  const [selectedRating, setSelectedRating] = useState([]);
  const [entKeyPeople, setEntKeyPeople] = useState([]);
  const [selectedKeyPerson, setSelectedKeyPerson] = useState([]);
  const [definedRegions, setDefinedRegions] = useState([]);
  const [definedSectors, setDefinedSectors] = useState([]);
  const [definedSubSectors, setDefinedSubSectors] = useState([]);
  const [entLatitude, setEntLatitude] = useState(null);
  const [entLongitude, setEntLongitude] = useState(null);
  const [entPlaceName, setEntPlaceName] = useState(null);

  const [entEmploymentStatus, setEntEmploymentStatus] = useState(null);
  const [entInstitution, setEntInstitution] = useState(null);
  const [entMonthlyPremium, setEntMonthlyPremium] = useState(0);
  const [entMonthlyIncome, setEntMonthlyIncome] = useState(0);
  const [entPremiumFlag, setEntPremiumFlag] = useState(null);
  const [entDisabled, setEntDisabled] = useState(null);
  const [entWard, setEntWard] = useState(null);
  const [entCounty, setEntCounty] = useState(null);
  const [premiumFlags, setPremiumFlags] = useState([]);
  const [employmentStatuses, setEmploymentStatuses] = useState([]);

  const [entWhatsapp, setEntWhatsapp] = useState("N");
  const [entWhatsappNo, setEntWhatsappNo] = useState(null);

  const [taxExemptReasons, setTaxExemptReasons] = useState([]);
  const [entTaxExempt, setEntTaxExempt] = useState("N");
  const [entTaxExemptReason, setEntTaxExemptReason] = useState(null);

  const [definedCharges, setDefinedCharges] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState([]);
  const [isEntityChargeDialogOpen, setIsEntityChargeDialogOpen] = useState(false);

  const [facilityLevels, setFacilityLevels] = useState([]);
  const [entFacilityLevel, setEntFacilityLevel] = useState(null);

  const [ledgerTypes, setLedgerTypes] = useState([]);
  const [selectedLedgerType, setSelectedLedgerType] = useState(null);
  const [selectedLedger, setSelectedLedger] = useState(null);

  const [ownershipTypes, setOwnershipTypes] = useState([]);
  const [accreditations, setAccreditations] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [searchTermEquipment, setSearchTermEquipment] = useState("");

  const [entOwnership, setEntOwnership] = useState(null);
  const [entFacilityWards, setEntFacilityWards] = useState([]);
  const [entFacilityTheatres, setEntFacilityTheatres] = useState([]);
  const [entApplicablePlans, setEntApplicablePlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [availablePlans, setAvailablePlans] = useState([]);
  const [selectedAvailablePlan, setSelectedAvailablePlan] = useState(null);

  const [entPharmacies, setEntPharmacies] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [selectedTheatre, setSelectedTheatre] = useState(null);
  const [entAmbulances, setEntAmbulances] = useState([]);
  const [entAccreditations, setEntAccreditations] = useState([]);

  const [ent24Hours, setEnt24Hours] = useState(null);
  const [entOperatingDays, setEntOperatingDays] = useState([]);
  const [entOpeningTime, setEntOpeningTime] = useState(null);
  const [entClosingTime, setEntClosingTime] = useState(null);

  const [entityGenderOptions, setEntityGenderOptions] = useState([]);
  const [entityStatusOptions, setEntityStatusOptions] = useState([]);
  const [entityCatgOptions, setEntityCatgOptions] = useState([]);
  const [entityTypeOptions, setEntityTypeOptions] = useState([]);

  const [selectedRelativeToAdd, setSelectedRelativeToAdd] = useState(null);
  const [selectedRelaType, setSelectedRelaType] = useState(null);
  const [relationshipTypes, setRelationshipTypes] = useState([]);
  const [relationships, setRelationships] = useState([]);
  const [searchTermRelationships, setSearchTermRelationships] = useState("");

  const [selectedAffiliationToAdd, setSelectedAffiliationToAdd] = useState(null);
  const [selectedAffiliationType, setSelectedAffiliationType] = useState(null);
  const [affiliationTypes, setAffiliationTypes] = useState([]);
  const [affiliations, setAffiliations] = useState([]);

  const [searchTermApps, setSearchTermApps] = useState("");
  const [otherAppTypes, setOtherAppTypes] = useState([]);
  const [entOtherApps, setEntOtherApps] = useState([]);
  const [selectedOtherApp, setSelectedOtherApp] = useState(null);
  const [otherAppCode, setOtherAppCode] = useState(null);

  const [searchTermAffiliations, setSearchTermAffiliations] = useState("");
  const [investorTypes, setInvestorTypes] = useState([]);
  const [selectedManagerToAdd, setSelectedManagerToAdd] = useState(null);
  const [selectedRoleToAdd, setSelectedRoleToAdd] = useState(null);
  const [accountManagers, setAccountManagers] = useState([]);
  const [users, setUsers] = useState([]);
  const [userRoles, setUserRoles] = useState([]);

  const [isAddDialogOpened, setIsAddDialogOpened] = useState(false);
  const [isAddDialogTitle, setIsAddDialogTitle] = useState("");
  const [newCode, setNewCode] = useState(null);
  const [newName, setNewName] = useState(null);
  const [newType, setNewType] = useState(null);
  const [newBeds, setNewBeds] = useState(0);
  const [theatreTypes, setTheatreTypes] = useState([]);
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});
  //entity saved files
  const [entityFilesData, setEntityFilesData] = useState([]);
  const [file, setFile] = useState(null);

  const parts = location.pathname.split("/");
  const [entityId, setEntityId] = useState(parts[parts.length - 1]);

  const person = location.state?.person;

  const actionsMenuRef = useRef(null);
  const entTypeRef = useRef(null);
  const [orgControls, setOrgControls] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentEquipmentPage, setCurrentEquipmentPage] = useState(0);
  const [img, setImg] = useState(undefined);
  const entityChargesRef = useRef(null);



  const handleEquipmentsPageChange = (event, newPage) => {
    setCurrentEquipmentPage(newPage);
  };

  const slicedEquipments = equipments?.slice(
    currentEquipmentPage * rowsPerPage,
    currentEquipmentPage * rowsPerPage + rowsPerPage
  );

  const handleEquipmentsRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentEquipmentPage(0);
  };

  // ratings table
  const [rowsPerPageRatings, setRowsPerPageRatings] = useState(5);
  const [currentPageRatings, setCurrentPageRatings] = useState(0);

  const handlePageChangeRating = (event, newPage) => {
    setCurrentPageRatings(newPage);
  };

  const handleRowsPerPageRatings = (event) => {
    setRowsPerPageRatings(parseInt(event.target.value, 5));
    setCurrentPageRatings(0);
  };

  const paginatedRatings = entRatings?.slice(
    currentPageRatings * rowsPerPageRatings,
    currentPageRatings * rowsPerPageRatings + rowsPerPageRatings
  );
  // ratings table

  // key people table
  const [rowsPerPageKeyPeople, setRowsPerPageKeyPeople] = useState(5);
  const [currentPageKeyPeople, setCurrentPageKeyPeople] = useState(0);

  const handlePageChangeKeyPeople = (event, newPage) => {
    setCurrentPageKeyPeople(newPage);
  };

  const handleRowsPerPageKeyPeople = (event) => {
    setRowsPerPageKeyPeople(parseInt(event.target.value, 5));
    setCurrentPageKeyPeople(0);
  };

  const paginatedKeyPeople = entKeyPeople?.slice(
    currentPageKeyPeople * rowsPerPageKeyPeople,
    currentPageKeyPeople * rowsPerPageKeyPeople + rowsPerPageKeyPeople
  );
  // key people table

  const handlePlaceSelect = (place) => {
    try {
      if (!place) {
        setSelectedPlace(null);
        setEntLatitude(null);
        setEntLongitude(null);
        setEntPlaceName(null);
        // console.log(`no place selected`);
      } else {
        // console.log(`Selected Place  ${JSON.stringify(place, null, 2)}`);
        setSelectedPlace(place);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
        setAdditionalActionsMenu(false);
      }
    }

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleSetEntityData = (field, value) => {
    setEntityData((prev) => {
      return { ...prev, [field]: value };
    });
  };

  const handleMonthlyIncomeBlur = (e) => {
    try {
      if (e.target.value) {
        const strippedValue = e.target.value.replace(/,/g, ""); // Remove commas
        if (isNaN(strippedValue)) {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const parsedValue = Big(strippedValue); // Use big.js to handle the value

        // Check if the parsed value is NaN
        if (!parsedValue.eq(parsedValue)) {
          setEntMonthlyIncome("");
        } else {
          setEntMonthlyIncome(formatAmountsToDecimals(parsedValue, 2));
        }
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleMonthlyPremiumBlur = (e) => {
    try {
      if (e.target.value) {
        const strippedValue = e.target.value.replace(/,/g, ""); // Remove commas
        if (isNaN(strippedValue)) {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const parsedValue = Big(strippedValue); // Use big.js to handle the value

        // Check if the parsed value is NaN
        if (!parsedValue.eq(parsedValue)) {
          setEntMonthlyPremium("");
        } else {
          setEntMonthlyPremium(formatAmountsToDecimals(parsedValue, 2));
        }
      }
    } catch (error) {
      console.log(error)
    }
  };


  const saveFileToDb = async (
    fl_name,
    fl_internal_name,
    fl_type,
    fl_path,
    fl_category,
    fl_size_kb,
    fl_parent_doc_id
  ) => {
    try {
      await newRequest.post(
        "/files/add",
        {
          fl_name: fl_name,
          fl_internal_name: fl_internal_name,
          fl_type: fl_type,
          fl_path: fl_path,
          fl_category: fl_category,
          fl_doc_type: "",
          fl_doc_no: "",
          fl_doc_index: "",
          fl_doc_sub_index: "",
          fl_ent_code: entCode,
          fl_aent_code: entAentCode?.value,
          fl_user_id: "",
          fl_size_kb,
          fl_parent_doc_id
        }
      );

      fetchEntityFiles(entityId);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const handleFirebaseFileUpload = async (file, folder) => {
    try {
      if (file) {
        if (uploadTarget === "firebase") {
          await uploadToFirebase(file, folder);
        } else {
          await uploadToBackend(file, folder);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    img && handleFirebaseFileUpload(img, "entity-profiles");
  }, [img]);

  const uploadToFirebase = async (file, fileFolder) => {
    setIsDialogOpen(true);
    const storage = getStorage(app);
    const fileName = new Date().getTime() + file.name;
    const fileExtension = file.name.split(".").pop(); // Get file extension
    const fileType = file.type; // Get file type
    const fileSizeKB = file.size / 1024; // Get file size in KB
    const storageRef = ref(
      storage,
      `qc_${currentUser.usr_org_code}/${fileFolder}/${fileName}`
    );
    const uploadTask = uploadBytesResumable(storageRef, file);

    // console.log(`fileName  ${fileName}`);
    // console.log(`fileExtension  ${fileExtension}`);
    // console.log(`fileType  ${fileType}`);
    // console.log(`fileSizeKB  ${fileSizeKB}`);
    // console.log(`storageRef  ${storageRef}`);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(Math.round(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        setIsDialogOpen(false);
        console.log(error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        // console.log(`downloadURL  ${JSON.stringify(downloadURL, null, 2)}`);
        if (fileFolder === "entity-profiles") {
          // update entity profile image

          try {
            await newRequest.put(
              "/allEntity/profileUpd/",
              {
                entity_docid: entityId,
                ent_photo_url: downloadURL,
                userCode: currentUser.usr_id,
                org_code: currentUser.usr_org_code,
              }
            );
            entityData.ent_photo_url = downloadURL;
            setEntPhotoUrl(downloadURL);
            // fetchEntityFiles(entityId);
            await newRequest.post(
              "/trace/add",
              {
                trc_action_on: "Entity",
                trc_doc_type: "Entity",
                trc_doc_no: entCode,
                trc_aent_code: entAentCode?.value,
                trc_ent_code: entCode,
                trc_action: "amended",
                trc_remarks: `uploaded new photo`,
                trc_tags: ["upload"],
                trc_doc_docid: entityId,
              }
            );
            fetchEntityTrace(entCode);
            setIsDialogOpen(false);
          } catch (error) {
            console.log(error);
            setIsDialogOpen(false);
          }
        } else {
          await saveFileToDb(
            file.name,
            fileName,
            fileExtension,
            downloadURL,
            "kyc",
            fileSizeKB,
            entityId
          );
          setFile("");
          setIsDialogOpen(false);
        }
      }
    );
  };

  // end of firebase

  // ---------- Upload to backend (multipart/form-data) ----------
  const uploadToBackend = async (file, fileFolder) => {
    const formData = new FormData();
    // metadata the backend can use to organize + save DB record
    formData.append("orgCode", currentUser.usr_org_code);
    formData.append("folder", fileFolder);
    formData.append("documentType", "Entity");
    formData.append("documentNo", entityData?.ent_code);
    formData.append("documentId", entityData?._id);
    formData.append("userCode", currentUser.usr_id);

    // IMPORTANT append file LAST
    formData.append("file", file);

    // optional: progress bar (axios supports onUploadProgress)
    const res = await newRequest.post("/uploadFiles/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evt) => {
        if (!evt.total) return;
        const progress = (evt.loaded / evt.total) * 100;
        setUploadProgress(Math.round(progress));
      },
    });

    await newRequest.put(
      "/allEntity/profileUpd/",
      {
        entity_docid: entityId,
        ent_photo_url: res.data?.file?.fl_path,
        userCode: currentUser.usr_id,
        org_code: currentUser.usr_org_code,
      }
    );
    entityData.ent_photo_url = res.data?.file?.fl_path;
    setEntPhotoUrl(res.data?.file?.fl_path);

    return res.data;
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "underReview") {
        // close account here
        const res = await newRequest.put(
          `/allEntity/upd/${entityId}`,
          {
            ent_status: "Under Review",
            ent_edgers: entLedgers
          }
        );
        if (res.status === 200) {
          await fetchEntity(entityData._id);
          navigate(`/entity/${entityData._id}`, { replace: true, });
          showToast(`${entName} successfully set to UNDER REVIEW!`, "success");
        } else {
          showToast(`Error putting ${entName} UNDER REVIEW!`, "error");
        }
      } else if (confirmDialogAction === "closeAccount") {
        // close account here
        const res = await newRequest.put(
          `/allEntity/upd/${entityId}`,
          {
            ent_status: "Closed",
            ent_edgers: entLedgers
          }
        );
        if (res.status === 200) {
          await fetchEntity(entityData._id);
          navigate(`/entity/${entityData._id}`, { replace: true, });
          showToast(`${entName} successfully CLOSED!`, "success");
        } else {
          showToast(`Error CLOSING ${entName}!`, "error");
        }
      } else if (confirmDialogAction === "reactivateAccount") {
        // reactivate account here
        const res = await newRequest.put(
          `/allEntity/upd/${entityId}`,
          {
            ent_status: "Active",
            ent_edgers: entLedgers
          }
        );
        if (res.status === 200) {
          await fetchEntity(entityData._id);
          navigate(`/entity/${entityData._id}`, { replace: true, });
          showToast(`${entName} successfully RE-ACTIVATED!`, "success");
        } else {
          showToast(`Error RE-ACTIVATING ${entName}!`, "error");
        }
      } else if (confirmDialogAction === "deleteTheatre") {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/allEntity/addFacilityDetails",
          {
            ent_docid: entityData._id,
            theatre_docid: objectToAction?.object_id,
            current_action: "deleteTheatre"
          }
        );
        setIsProcessing(false);
        if (res.data?.msg === "deleted") {
          setEntFacilityTheatres((prev) => prev.filter(param => param._id !== objectToAction?.object_id));
          showToast(`Deleted!`, "success");
        } else {
          showToast(`error deleting theatre!`, "error");
        }
      } else if (confirmDialogAction === "deletePharmacy") {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/allEntity/addFacilityDetails",
          {
            ent_docid: entityData._id,
            pharmacy_docid: objectToAction?.object_id,
            current_action: "deletePharmacy"
          }
        );
        setIsProcessing(false);
        if (res.data?.msg === "deleted") {
          setEntPharmacies((prev) =>
            prev.filter(param => param._id !== objectToAction?.object_id)
          );
          showToast(`Deleted!`, "success");
        } else {
          showToast(`error deleting pharmacy!`, "error");
        }
      } else if (confirmDialogAction === "deleteWard") {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/allEntity/addFacilityDetails",
          {
            ent_docid: entityData._id,
            ward_docid: objectToAction?.object_id,
            current_action: "deleteWard"
          }
        );
        setIsProcessing(false);
        if (res.data?.msg === "deleted") {
          setEntFacilityWards((prev) =>
            prev.filter(param => param._id !== objectToAction?.object_id)
          );
          showToast(`Deleted!`, "success");
        } else {
          showToast(`error deleting ward!`, "error");
        }
      } else if (confirmDialogAction === "deletePlan") {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/allEntity/addFacilityDetails",
          {
            ent_docid: entityData._id,
            plan_code: objectToAction?.object_id,
            current_action: confirmDialogAction
          }
        );
        setIsProcessing(false);
        if (res.data?.msg === "deleted") {
          setEntApplicablePlans((prev) => prev.filter(param => param.plan_code !== objectToAction?.object_id));
          showToast(`Deleted!`, "success");
        } else {
          showToast(`error deleting record!`, "error");
        }
      } else if (confirmDialogAction === "removeLedger") {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/allEntity/removeLedger",
          {
            entity_docid: entityData._id,
            ledger_type: objectToAction?.object_id
          }
        );
        setIsProcessing(false);
        if (res.data?.msg === "removed") {
          setEntLedgers((prev) => prev.filter(param => param.ledger_type !== objectToAction?.object_id));
          showToast(`Removed!`, "success");
        } else {
          showToast(`error deleting record!`, "error");
        }
      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const getOrgControls = async () => {
    try {
      const res = await newRequest.get("/allEntity/getOrgControls");
      // console.log(`getOrgControls  ${JSON.stringify(res.data, null, 2)}`);
      setOrgControls(res.data);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchEntity = async (id) => {
    try {
      const res = await newRequest.get(`/allEntity/findById/${id}`);
      setEntityId(res.data?._id);
      setEntityData(res.data);

      //  entity type
      if (res.data?.ent_type) {
        setEntType({
          value: res.data?.ent_type,
          label: res.data?.entity_type_xx,
        });
      } else {
        setEntType(null);
      }


      // category
      if (res.data?.ent_aent_code) {
        setEntAentCode({
          aent_layouts: res.data?.aent_layouts,
          value: res.data?.ent_aent_code,
          label: res.data?.aent_name_xx,
        });
      } else {
        setEntAentCode(null);
      }

      if (res.data?.ent_gender) {
        setEntGender({
          value: res.data?.ent_gender,
          label: res.data?.gender_xx,
        });
      } else {
        setEntGender(null);
      }

      if (res.data?.ent_status) {
        setEntStatus({
          value: res.data?.ent_status,
          label: res.data?.entity_status_xx,
        });
      } else {
        setEntStatus(null);
      }

      if (res.data?.ent_occupation) {
        setEntOccupation({
          value: res.data?.ent_occupation,
          label: res.data?.ent_occupation_xx,
        });
      } else {
        setEntOccupation(null);
      }

      if (res.data?.ent_smoke_flag) {
        setEntSmokeFlag({
          value: res.data?.ent_smoke_flag,
          label: res.data?.smoke_flag_xx,
        });
      } else {
        setEntSmokeFlag(null);
      }

      if (res.data?.ent_surname) {
        setEntSurname(res.data?.ent_surname);
      } else {
        setEntSurname("");
      }

      setEntCode(res.data?.ent_code);
      setEntName(res.data?.ent_name);
      setEntAlias(res.data?.ent_alias);

      setEntOtherNames(res.data?.ent_other_names);
      setEntIdNo(res.data?.ent_id_no);
      setEntTaxNo(res.data?.ent_tax_no);
      setEntLicenseNo(res.data?.ent_licence_no);
      setEntPhoneNo(res.data?.ent_phone_no);
      setEntEmail(res.data?.ent_email);
      setEntPhotoUrl(res.data?.ent_photo_url);
      setEntPhysicalAddress(res.data?.ent_physical_address);
      setEntPostalAddress(res.data?.ent_postal_address);

      // google places
      setEntLatitude(res.data?.ent_latitude);
      setEntLongitude(res.data?.ent_longitude);
      setEntPlaceName(res.data?.ent_place_name);

      if (res.data?.ent_dob) {
        const formattedDate = moment(res.data?.ent_dob).format("YYYY-MM-DD");
        setEntDob(formattedDate);
      } else {
        setEntDob(null);
      }

      if (res.data?.ent_age_xx) {
        setEntAgeXx(res.data?.ent_age_xx)
      } else {
        setEntAgeXx(" years")
      }

      if (res.data?.document_enabled_xx) {
        setDocumentEnabled(res.data?.document_enabled_xx);
      } else {
        setDocumentEnabled("Y");
      }

      if (res.data?.save_enabled_xx) {
        setSaveEnabled(res.data?.save_enabled_xx);
      } else {
        setSaveEnabled("Y");
      }

      if (res.data?.next_action_xx) {
        setNextAction(res.data?.next_action_xx);
      } else {
        setNextAction("None");
      }

      if (res.data?.ent_employment_status) {
        setEntEmploymentStatus({
          value: res.data?.ent_employment_status,
          label: res.data?.ent_employment_status_xx,
        });
      } else {
        setEntEmploymentStatus(null);
      }

      if (res.data?.ent_institution) {
        setEntInstitution({
          value: res.data?.ent_institution,
          label: res.data?.ent_institution_xx,
        });
      } else {
        setEntInstitution(null);
      }

      if (res.data?.ent_premium_flag) {
        setEntPremiumFlag({
          value: res.data?.ent_premium_flag,
          label: res.data?.ent_premium_flag_xx,
        });
      } else {
        setEntPremiumFlag(null);
      }

      if (res.data?.ent_ward) {
        setEntWard({
          value: res.data?.ent_ward,
          label: res.data?.ent_ward_xx,
        });
      } else {
        setEntWard(null);
      }

      if (res.data?.ent_county) {
        setEntCounty({
          value: res.data?.ent_county,
          label: res.data?.ent_county_xx,
        });
      } else {
        setEntCounty(null);
      }

      if (res.data?.ent_monthly_income) {
        const formattedValue = formatAmountsToDecimals(res.data?.ent_monthly_income);
        setEntMonthlyIncome(formattedValue)
      } else {
        setEntMonthlyIncome(0);
      }

      if (res.data?.ent_monthly_premium) {
        const formattedValue = formatAmountsToDecimals(res.data?.ent_monthly_premium);
        setEntMonthlyPremium(formattedValue)
      } else {
        setEntMonthlyPremium(0);
      }

      if (res.data?.ent_facility_level) {
        setEntFacilityLevel({
          desc: res.data?.facility_desc_xx,
          value: res.data?.ent_facility_level,
          label: res.data?.ent_facility_level_xx,
        });
      } else {
        setEntFacilityLevel(null);
      }

      setEntDisabled(res.data?.ent_disabled);
      setEntWhatsapp(res.data?.ent_whatsapp);
      setEntWhatsappNo(res.data?.ent_whatsapp_no);

      setEntTaxExempt(res.data?.ent_tax_exempt);
      if (res.data?.ent_tax_exempt_reason) {
        setEntTaxExemptReason({
          value: res.data?.ent_tax_exempt_reason,
          label: res.data?.ent_tax_exempt_reason_xx,
        });
      } else {
        setEntTaxExemptReason(null);
      }

      // set relationships
      if (res.data?.relationships_xx) {
        setRelationships(res.data?.relationships_xx);
      } else {
        setRelationships([]);
      }

      // set affiliations
      if (res.data?.affiliations_xx) {
        setAffiliations(res.data?.affiliations_xx);
      } else {
        setAffiliations([]);
      }

      if (res.data?.ent_other_apps) {
        setEntOtherApps(res.data?.ent_other_apps);
      } else {
        setEntOtherApps([]);
      }

      setEntFacilityWards(res.data?.facility_wards_xx);
      setEntFacilityTheatres(res.data?.ent_facility_theatres);
      setEntPharmacies(res.data?.ent_pharmacies);
      setEntAmbulances(res.data?.ent_ambulances);
      setEntAccreditations(res.data?.ent_accreditations);
      setEntLedgers(res.data?.ent_ledgers);


      setEntApplicablePlans(res.data?.applicable_plans_xx);

      if (res.data?.ent_ownership) {
        setEntOwnership({
          value: res.data?.ent_ownership,
          label: res.data?.ent_ownership,
        });
      } else {
        setEntOwnership(null);
      }

      setEnt24Hours(res.data?.ent_24_hours);
      setEntOperatingDays(res.data?.ent_operating_days);
      setEntOpeningTime(res.data?.ent_opening_time);
      setEntClosingTime(res.data?.ent_closing_time);

      setEntRatings(res.data?.ent_ratings);
      setEntKeyPeople(res.data?.ent_key_people || []);
      if (res.data?.document_enabled_xx === "Y") {
        fetchListing();
      }
      // fet account getManagers
      await fetchAccountManagers(res.data?.ent_aent_code, res.data?.ent_code);
      //Fetch Entity Files
      fetchEntityFiles(entityId);
      // fetch trace data
      fetchEntityTrace(res.data?.ent_code);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchEntityFiles = async (entity_docid) => {
    try {
      const res = await newRequest.post("/files/findEntityFiles", { entity_docid: entity_docid });
      setEntityFilesData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchEntityTrace = async (entity_code) => {
    try {
      const res = await newRequest.post("/trace/findEnt", { trc_ent_code: entity_code });
      setEntityTraceData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAvailablePlans = async () => {
    try {
      const res = await newRequest.post(
        "/plans/findAll",
        {
          result_limit: 100,
          lean: "Y"
        }
      );
      const options = res.data?.map((codes) => ({
        value: codes.plan_code,
        label: codes.plan_name,
      }));
      setAvailablePlans(options);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchLedgerTypes = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Ledger Type" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setLedgerTypes(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };

  const fetchPremiumFlags = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Premium Flag" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setPremiumFlags(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };

  const fetchFacilityLevels = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Facility Levels" }
      );
      const options = res.data?.map((codes) => ({
        desc: codes?.sys_desc,
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setFacilityLevels(options);


    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };

  const fetchTheatreTypes = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Theatre Types" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setTheatreTypes(options);
    } catch (error) {
      console.error("Error fetching Employment Status :", error);
    }
  };

  const fetchRegions = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Fund Regions" });
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setDefinedRegions(options);
    } catch (error) {
      console.error("Error fetching regions :", error);
    }
  };

  const fetchDefinedCharges = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Charges" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setDefinedCharges(options);
    } catch (error) {
      console.error("Error fetching report templates types:", error);
    }
  };

  const fetchEmploymentStatus = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Employment Status" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setEmploymentStatuses(options);
    } catch (error) {
      console.error("Error fetching Employment Status :", error);
    }
  };

  const fetchTaxExemptReasons = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Tax Exempt Reasons" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setTaxExemptReasons(options);
    } catch (error) {
      console.error("Error fetching Employment Status :", error);
    }
  };

  const fetchOwnershipTypes = async () => {
    try {
      const options = ["Public", "Private", "Unspecified"].map((ot) => ({
        value: ot,
        label: ot,
      }));

      setOwnershipTypes(options);

    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };


  const fetchFacilityAccreditations = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Facility Accreditations" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setAccreditations(options);
    } catch (error) {
      console.error("Error fetching Employment Status :", error);
    }
  };

  const fetchTheatreEquipments = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Theatre Equipments" }
      );
      setEquipments(res.data);
    } catch (error) {
      console.error("Error fetching Employment Status :", error);
    }
  };

  const fetchDefinedRegions = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Fund Regions" });
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setDefinedRegions(options);
    } catch (error) {
      console.error("Error fetching security types :", error);
    }
  };

  const fetchDefinedSectors = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findNullGrp", { sys_type: "AM Sectors" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setDefinedSectors(options);
    } catch (error) {
      console.error("Error fetching defined sectors :", error);
    }
  };

  const fetchDefinedSubSectors = async (sectorCode) => {
    try {
      const res = await newRequest.post("/sysCode/findGrp", { sys_type: "AM Sectors", sys_grouping: sectorCode });
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setDefinedSubSectors(options);
    } catch (error) {
      console.error("Error fetching defined sectors :", error);
    }
  };

  // smoking flag
  const fetchSmokingFlags = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Smoke Flag" }
      );
      const options = res.data?.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setSmokingFlags(options);
    } catch (error) {
      console.error("Error fetching smoke flags :", error);
    }
  };


  const actionOnEntity = async () => {
    try {
      const entityValidated = await validateEntries("Y");
      // console.log(`entityValidated ... ${entityValidated}`);
      if (!entityValidated) return;

      if (entType) {

        let valueXx = "N";
        let limitXx = "N";

        if (nextAction === "Activate") {
          if (entType.value === "Corporate") {
            limitXx = "GB1000";
            valueXx = getLimitValue(limitXx);
          } else if (entType.value === "Government") {
            limitXx = "GB1001";
            valueXx = getLimitValue(limitXx);
          } else if (entType.value === "Individual") {
            limitXx = "GB1002";
            valueXx = getLimitValue(limitXx);
          } else if (entType.value === "NGO") {
            limitXx = "GB1003";
            valueXx = getLimitValue(limitXx);
          } else {
            limitXx = "GB1004";
            valueXx = getLimitValue(limitXx);
          }

          if (valueXx === "N") {
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(`${limitXx}: You are not authorized to activate ${entType.value} accounts!`);
            setIsNotifyDialogOpen(true);
            return;
          }

          // activate account here
          const res = await newRequest.put(
            `/allEntity/upd/${entityId}`,
            {
              ent_status: "Active",
              ent_edgers: entLedgers
            }
          );

          if (res.status === 200) {
            await fetchEntity(entityId);
            showToast(`${entName} status changed to Active!`, "success");
          } else {
            showToast(`Error updating ${entName} status to Active!`, "error");
          }
        } else if (nextAction === "Re-Activate") {
          limitXx = "GB1007";
          valueXx = getLimitValue(limitXx);
          if (valueXx === "N") {
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(`${limitXx}: You are not authorized to RE-ACTIVATE this account!`);
            setIsNotifyDialogOpen(true);
            return;
          }

          // reactivate account here
          const res = await newRequest.put(`/allEntity/upd/${entityId}`, { ent_status: "Active", ent_edgers: entLedgers });

          if (res.status === 200) {
            await fetchEntity(entityId);
            showToast(`${entName} successfully RE-ACTIVATED!`, "success");
          } else {
            showToast(`Error RE-ACTIVATING ${entName}!`, "error");
          }
        }
      } else {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select type!`);
        setIsNotifyDialogOpen(true);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };


  const validateEntries = async (includingDocuments = "N") => {

    if (!entType?.value) {
      setNotifyDialogTitle("Note!");
      setNotifyDialogText(`Please select type!`);
      setIsNotifyDialogOpen(true);
      return false;
    }

    if (!entAentCode?.value) {
      setNotifyDialogTitle("Note!");
      setNotifyDialogText(`Please select category!`);
      setIsNotifyDialogOpen(true);
      return false;
    }

    if (!entStatus?.value) {
      setNotifyDialogTitle("Note!");
      setNotifyDialogText(`Please select status!`);
      setIsNotifyDialogOpen(true);
      return false;
    }

    if (!entName) {
      setNotifyDialogTitle("Note!");
      setNotifyDialogText(`Please enter name!`);
      setIsNotifyDialogOpen(true);
      return false;
    }

    // validate whataspp number
    if (entityData?.ent_whatsapp === "Y") {
      if (!entityData?.ent_whatsapp_no) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please specify valid WhatsApp Number!`);
        setIsNotifyDialogOpen(true);
        return false;
      } else {
        if (!isValidMobileNumber(entityData?.ent_whatsapp_no)) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please specify valid WhatsApp Number!`);
          setIsNotifyDialogOpen(true);
          return false;
        }
      }
    }

    // validate whataspp number
    if (entityData?.ent_tax_exempt === "Y" && !entityData?.ent_tax_exempt_reason) {
      setNotifyDialogTitle("Note!");
      setNotifyDialogText(`Please specify reason for tax exemption!`);
      setIsNotifyDialogOpen(true);
      return false;
    }

    // validate documents
    if (includingDocuments === "Y" && orgControls?.org_activate_kyc === "Y") {
      const docs = await newRequest.post("/allEntityCatg/find", { aent_code: entAentCode?.value });
      // console.log(`ValidationMessages messageData ${JSON.stringify(docs.data?.aent_required_docs, null, 2)}`);
      // console.log(`entityFilesData ${JSON.stringify(entityFilesData, null, 2)}`);
      const missingDocsResult = validateMandatoryDocuments(docs.data?.aent_required_docs, entType?.value, entityFilesData);
      // console.log(`missingDocsResult ${JSON.stringify(missingDocsResult, null, 2)}`);
      if (missingDocsResult?.result_status === "error") {
        setValidationMessagesResult(missingDocsResult);
        setIsConfirmDialogOpen(false);
        setValidationMsgDialog(true);
        return false;
      }
    }

    return true;
  }

  const saveRecord = async (e) => {
    // e.preventDefault();
    try {
      const entityValidated = await validateEntries("N");
      // console.log(`entityValidated ... ${entityValidated}`);
      if (!entityValidated) return;

      // console.log(`entityData ${JSON.stringify(entityData, null, 2)}`);
      if (entityId !== "new") {
        const formattedRatings = entRatings
          .filter(obj => obj.rate !== "" && obj.rate !== null)
          .map(({ _id, ...rest }) => ({
            ...rest
          }));

        const formattedKeyPeople = entKeyPeople
          .filter(obj => obj.person_name !== "" && obj.person_name !== null)
          .map(({ _id, ...rest }) => ({
            ...rest
          }));
        // console.log(`entTaxExemptReason ${JSON.stringify(entTaxExemptReason, null, 2)}`);
        await newRequest.put(
          `/allEntity/upd/${entityId}`,
          {
            ...entityData,
            docId: entityId,
            ent_phone_no: normalizePhoneNumber(entPhoneNo),
            ent_whatsapp_no: normalizePhoneNumber(entWhatsappNo),
            ent_latitude: entLatitude,
            ent_longitude: entLongitude,
            ent_place_name: entPlaceName,
            ent_monthly_income: formatStringToNumberV2(entMonthlyIncome),
            ent_monthly_premium: formatStringToNumberV2(entMonthlyPremium),
            ent_ledgers: entLedgers,
            ent_ratings: formattedRatings,
            ent_key_people: formattedKeyPeople,
          }
        );

        if (entityChargesRef.current?.updateCharges) {
          await entityChargesRef.current.updateCharges();
          console.log("charges updated");
        }

        await fetchEntityTrace(entCode);
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`Successfully saved`);
        setIsNotifyDialogOpen(true);
      } else {
        // if (!entCode) {
        //   const res = await newRequest.post("/allEntity/gen", { entity_name: entName, person });
        //   logData("entCode",res.data);
        //   updatedAllEntity = { ...entityData, ent_code: res.data };
        //   setEntCode(res.data);
        // } else {
        //   updatedAllEntity = { ...entityData };
        // }

        const res = await newRequest.post(
          "/allEntity/add",
          {
            ...entityData,
            ent_person: person,
            ent_phone_no: normalizePhoneNumber(entPhoneNo),
            ent_whatsapp_no: normalizePhoneNumber(entWhatsappNo) || null,
            ent_latitude: entLatitude,
            ent_longitude: entLongitude,
            ent_place_name: entPlaceName,
            ent_monthly_income: formatStringToNumberV2(entMonthlyIncome) || 0,
            ent_monthly_premium: formatStringToNumberV2(entMonthlyPremium) || 0,
            ent_docs_verified: orgControls?.org_activate_kyc === "N" ? "Y" : entityData?.ent_docs_verified

          }
        );

        // console.log(`entityData add  ${JSON.stringify(res.data, null, 2)}`);

        if (res.status === 200) {
          // ok response
          setEntityId(res.data?._id);
          await newRequest.post(
            "/trace/add",
            {
              trc_org_code: currentUser.usr_org_code,
              trc_action_on: "Entity",
              trc_doc_type: "Entity",
              trc_doc_no: res.data?.ent_code,
              trc_aent_code: res.data?.ent_aent_code,
              trc_ent_code: res.data?.ent_code,
              trc_action: "created",
              trc_remarks: `created this account`,
              trc_tags: ["creation"],
              trc_doc_docid: res.data?._id,
            }
          );
          setIsProcessing(true);
          await fetchEntity(res.data?._id);
          navigate(`/entity/${res.data?._id}`, { replace: true, });
          setIsProcessing(false);
          setNotifyDialogTitle("Success!");
          setNotifyDialogText(`Details successfully saved`);
          setIsNotifyDialogOpen(true);
        } else {
          setEntCode("");
          // error response
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(res.data);
          setIsNotifyDialogOpen(true);
        }
      }
    } catch (err) {
      let dialogText = "An error occurred.";
      setEntCode("");
      if (err.response && err.response.status === 400) {
        const { message, errors } = err.response.data;
        if (errors && Array.isArray(errors)) {
          // Format validation errors for display
          const errorMessages = errors.map((e) => `• ${e.message}`).join("\n");
          dialogText = `${message}\n\n${errorMessages}`;
        } else if (message) {
          dialogText = message;
        }
      } else if (err.message) {
        // Handle generic errors
        dialogText = err.message;
      }
      // console.log(`dialogText  ${JSON.stringify(dialogText, null, 2)}`);
      // Set the dialog content
      setNotifyDialogTitle("Validation Error");
      setNotifyDialogText(dialogText);
      setIsNotifyDialogOpen(true);
    }
  };

  const handleNewAction = async () => {
    try {

      if (["addWard"].includes(currentAction) && !newCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter ward no!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (["addWard", "addTheatre", "addPharmacy"].includes(currentAction) && !newName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(currentAction === "addAmbulance" ? `Please enter registration no!` : `Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (["addTheatre"].includes(currentAction) && !newType?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select type!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (["addWard"].includes(currentAction) && !newBeds) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please specify no of beds!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);

      const res = await newRequest.post(
        "/allEntity/addFacilityDetails",
        {
          ent_docid: entityData._id,
          current_action: currentAction,
          code: newCode,
          name: newName,
          type: newType?.value,
          no_of_beds: newBeds,
          plan_code: selectedAvailablePlan?.value
        }
      );

      setIsProcessing(false);
      // console.log(`reponse ${JSON.stringify(res.data, null, 2)}`);
      if (res.data?.msg === "added") {
        if (currentAction === "addWard") {
          setEntFacilityWards((prev) => [...prev, res.data?.doc]);
        } else if (currentAction === "addTheatre") {
          setEntFacilityTheatres((prev) => [...prev, res.data?.doc]);
        } else if (currentAction === "addPharmacy") {
          setEntPharmacies((prev) => [...prev, res.data?.doc]);
        } else if (currentAction === "addPlan") {
          setEntApplicablePlans((prev) => [...prev, res.data?.doc]);
        }

        setNewCode(null);
        setNewName(null);
        setNewType(null);
        setNewBeds(0);
        setIsAddDialogOpened(false);
        showToast("Added!", "success");
      } else if (res.data?.msg === "exists") {
        showToast("Selected value already exists!", "error");
      } else {
        showToast("Error adding value!", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };


  const fetchEntityType = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll",
        {
          sys_org_code: currentUser.usr_org_code,
          sys_type: person === "Y" ? "People Types" : "Entity Types",
        }
      );

      const options = res.data?.map((entityType) => ({
        value: entityType?.sys_code,
        label: entityType?.sys_name,
      }));

      setEntityTypeOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchEntityCatg = async () => {
    try {
      const res = await newRequest.get("/allEntityCatg/findAll");
      const options = res.data?.map((entityCatg) => ({
        aent_layouts: entityCatg?.aent_layouts,
        value: entityCatg?.aent_code,
        label: entityCatg?.aent_name,
      }));
      setEntityCatgOptions(options);
    } catch (error) {
      console.error("Error fetching entity category:", error);
    }
  };


  const fetchEntityStatus = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll",
        {
          sys_org_code: currentUser.usr_org_code,
          sys_type: "Entity Status",
        }
      );

      const options = res.data?.map((entityStatus) => ({
        value: entityStatus.sys_code,
        label: entityStatus.sys_name,
      }));

      setEntityStatusOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  // entity gender
  const fetchEntityGender = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Gender" });

      const options = res.data?.map((entityGender) => ({
        value: entityGender?.sys_code,
        label: entityGender?.sys_name,
      }));

      setEntityGenderOptions(options);
    } catch (error) {
      console.error("Error fetching entity Gender:", error);
    }
  };

  const fetchProfileLimits = async () => {
    try {
      const limitsToCheck = ["GB1000", "GB1001", "GB1002", "GB1003", "GB1004", "GB1005", "GB1006", "GB1007", "GB1008", "GB1009", "GB1010"];
      const limits = await newRequest.post("/adProfile/checkValues", { module_code: "gb", limit_codes: limitsToCheck });
      setProfileLimitValues(limits.data)
    } catch (error) {
      console.log(error)
    }
  }

  // Function to get limit_yn value by limit_code
  const getLimitValue = (limitCode) => {
    try {
      const limit = profileLimitValues.find(l => l.limit_code === limitCode);
      return limit ? limit.limit_yn : null;
    } catch (error) {
      console.log(error)
    }
  };

  const fetchAccountManagers = async (aentCode, entCode) => {
    try {

      const res = await newRequest.post(
        "/allEntityManager/findAll", {
        em_aent_code: aentCode,
        em_ent_code: entCode,
        em_user_role: ""
      });

      // console.log(`/allEntityManager/findAll  ${JSON.stringify(res.data, null, 2)}`);
      setAccountManagers(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await newRequest.post(
        "/adUser/findAll",
        {
          usr_org_code: currentUser.usr_org_code,
        }
      );
      const options = res.data?.map((user) => ({
        value: user._id,
        label: user.usr_full_name,
      }));

      setUsers(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchUserRoles = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Account Role" });
      const options = res.data?.map((role) => ({
        value: role.sys_code,
        label: role.sys_name,
      }));

      setUserRoles(options);
    } catch (error) {
      console.error("Error fetching type types:", error);
    }
  };

  const fetchRelationshipType = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Relationship Type" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setRelationshipTypes(options);
    } catch (error) {
      console.error("Error fetching relationship types:", error);
    }
  };

  const fetchAffiliationType = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Affiliations" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setAffiliationTypes(options);
    } catch (error) {
      console.error("Error fetching affiliations types:", error);
    }
  };

  const fetchAppTypes = async () => {
    try {
      const options = ["DMVIC", "MPESA", "BIMA"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setOtherAppTypes(options);
    } catch (error) {
      console.error("Error fetching affiliations types:", error);
    }
  };

  const fetchInvestorTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Investor Type" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_code,
      }));
      setInvestorTypes(options);
    } catch (error) {
      console.error("Error fetching fund types :", error);
    }
  };

  const handleAddManager = async () => {
    try {

      if (!selectedManagerToAdd?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Select manager!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!selectedRoleToAdd?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Select role!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      const res = await newRequest.post(
        "/allEntityManager/add",
        {
          em_aent_code: entAentCode?.value,
          em_ent_code: entCode,
          em_user_id: selectedManagerToAdd?.value,
          em_user_role: selectedRoleToAdd?.value
        }
      );

      if (res.data === "exists") {
        showToast(`User ${selectedManagerToAdd.label} is already ${selectedRoleToAdd?.value}`, "error");
      } else {
        showToast(`User ${selectedManagerToAdd.label} added as ${selectedRoleToAdd?.value}`, "success");
      }
      setSelectedManagerToAdd(null);
      setSelectedRoleToAdd(null);
      await fetchAccountManagers(entAentCode?.value, entCode);
    } catch (error) {
      console.log(error);
    }
  };


  const handleRemoveEquipment = async (theatre_docid, equipment_docid) => {
    try {
      setIsProcessing(true);
      await newRequest.post(
        "/allEntity/addFacilityDetails",
        {
          ent_docid: entityData._id,
          theatre_docid,
          equipment_docid,
          current_action: "deleteTheatreEquipment"
        }
      );

      setEntFacilityTheatres(prevTheatres =>
        prevTheatres.map(theatre => {
          if (theatre._id === theatre_docid) {
            return {
              ...theatre,
              theatre_equipments: theatre.theatre_equipments.filter(
                equipment => equipment._id !== equipment_docid
              )
            };
          }
          return theatre;
        })
      );

      setIsProcessing(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleRatingsChange = (e, id, field) => {
    try {
      const newData = [...entRatings];
      const index = newData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newData[index][field] = e.target.value;
        newData[index]["flag_xx"] = "new";
        setEntRatings(newData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyPeopleChange = (e, id, field) => {
    try {
      const newData = [...entKeyPeople];
      const index = newData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        if (e && e.target) {
          // Regular input
          newData[index][field] = e.target.value;
        } else if (e && typeof e === "object") {
          // react-select returns the whole selected option object
          newData[index][field] = e.value;
        }
        newData[index]["flag_xx"] = "new";
        setEntKeyPeople(newData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEntityNavigate = async (id) => {
    try {
      setIsProcessing(true);
      await fetchEntity(id);
      navigate(`/entity/${id}`, { replace: true, });
      setIsProcessing(false);
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
    }
  };

  // const handleDayChange = (e) => {
  //   try {
  //     const { value, checked } = e.target;
  //     setEntOperatingDays((prevDays) =>
  //       checked ? [...prevDays, value] : prevDays.filter((day) => day !== value)
  //     );

  //     // Update entity data if needed
  //     handleSetEntityData(
  //       "ent_operating_days",
  //       checked ? [...entOperatingDays, value] : entOperatingDays.filter((day) => day !== value)
  //     );
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleDayChange = (event) => {
    const { value, checked } = event.target;
    setEntOperatingDays((prevDays) =>
      checked ? [...prevDays, value] : prevDays.filter((day) => day !== value)
    );

    // Update entity data if needed
    handleSetEntityData(
      "ent_operating_days",
      checked ? [...entOperatingDays, value] : entOperatingDays.filter((day) => day !== value)
    );
  };

  // refresh sub sectors based on sector
  useEffect(() => {
    fetchDefinedSubSectors(entityData?.ent_sector);
  }, [entityData?.ent_sector]);


  const fetchListing = () => {
    fetchEntityStatus();
    fetchEntityType();
    fetchEntityCatg();
    fetchEntityGender();
    fetchProfileLimits();
    fetchSmokingFlags();
    fetchEmploymentStatus();
    fetchPremiumFlags();
    fetchRelationshipType();
    fetchFacilityLevels();
    fetchOwnershipTypes();
    fetchFacilityAccreditations();
    fetchTheatreTypes();
    fetchAffiliationType();
    fetchLedgerTypes();
    fetchRegions();
    fetchDefinedSectors();
    fetchInvestorTypes();
    fetchTaxExemptReasons();
    fetchAppTypes();
    fetchDefinedCharges();
  };

  useEffect(() => {
    //if entity is selected, use entityId to get entity details
    //if its new record, no fetch is necessary
    if (entityId !== "new") {
      fetchEntity(entityId);
      fetchUsers();
      fetchUserRoles();
    } else {
      setEntStatus({
        value: "New",
        label: "New",
      });
      if (entTypeRef.current) {
        entTypeRef.current.focus();
      }
      fetchListing();
    }
    getOrgControls();
  }, [entityData?.ent_code]);

  return (
    <motion.div
      className="all-entity"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="all-entity-main-wrapper">
          <div className="center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <h1 className="page-title">{entityData?.ent_name?.toUpperCase() || t('new').toUpperCase()}</h1>
                </div>
                <div className="navbar-right">
                  {entityId !== "new" && ["Under Review", "New"].includes(entStatus?.value) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#fbbf24"
                      endIcon={<DoneAllIcon />}
                      onClick={actionOnEntity}>
                      {nextAction}
                    </CustomLoadingButton>}
                  {saveEnabled === "Y" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#00D37F"
                      tooltip="Save changes"
                      endIcon={<FaSave />}
                      onClick={saveRecord}>
                      {t('save')}
                    </CustomLoadingButton>}
                  {entityId !== "new" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#2563EB"
                      tooltip="Run reports for this document"
                      endIcon={<IoDocumentTextSharp />}
                      onClick={() => setReportsDialogOpen(true)}>
                      {t('reports')}
                    </CustomLoadingButton>}
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#f55656"
                    tooltip="Close this document"
                    endIcon={<IoClose />}
                    onClick={() => { navigate(-1) }}>
                    {t('close')}
                  </CustomLoadingButton>
                  <div className="icon-container"
                    ref={actionsMenuRef}
                    onClick={(e) => {
                      try {
                        e.stopPropagation();
                        setAdditionalActionsMenu(!additionalActionsMenu)
                      } catch (error) {
                        console.log(error)
                      }
                    }}>
                    <MdOutlineMenuOpen className="icon" />
                    {additionalActionsMenu && (
                      <div className="dropdown">
                        <div className="dropdown-item">{t('form')}</div>
                        {entStatus?.value === "Active" &&
                          <div className="dropdown-item"
                            onClick={() => {
                              try {
                                if (getLimitValue("GB1005") === "N") {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`GB1005: You are not authorized to put ${entName} Under Review!`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }
                                const action_text = `Are you sure you want to put ${entName} UNDER REVIEW?. Please note all transactions related to this entity that are in progress cannot be approved until the account returns to ACTIVE state.`;
                                setObjectToAction({
                                  object_id: entityId,
                                  action_text: action_text,
                                });
                                setConfirmDialogAction("underReview");
                                setIsConfirmDialogOpen(true);
                              } catch (error) {
                                console.log(error)
                              }
                            }}>{t('underReview')}</div>}
                        {entStatus?.value === "Under Review" &&
                          <div className="dropdown-item"
                            onClick={() => {
                              try {
                                if (getLimitValue("GB1007") === "N") {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`GB1007: You are not authorized to RE-ACTIVATE ${entName}!`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }
                                setObjectToAction({
                                  object_id: entityId,
                                  action_text: `Are you sure you want to RE-ACTIVATE ${entName}?`,
                                });
                                setConfirmDialogAction("reactivateAccount");
                                setIsConfirmDialogOpen(true);
                              } catch (error) {
                                console.log(error)
                              }
                            }}
                          >{t('reactivate')}</div>}
                        {entStatus?.value === "Active" && <div className="dropdown-item"
                          onClick={() => {
                            try {
                              if (getLimitValue("GB1006") === "N") {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`GB1006: You are not authorized to CLOSE ${entName}!`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }
                              setObjectToAction({
                                object_id: entityId,
                                action_text: `Are you sure you want to CLOSE ${entName}?. Please note this action is irrevasible. A CLOSED account CANNOT be reopened. All transactions related to this entity that are in progress cannot be approved.`,
                              });
                              setConfirmDialogAction("closeAccount");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error)
                            }
                          }}
                        >{t('closeAccount')}</div>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <ExpandableComponent
                title={t('basicInformation').toUpperCase()}
                subtitle={
                  entityId === "new" ?
                    <div className="input-item-with-label">
                      {/* <label htmlFor="ent_code" className="form-input-label" style={{ width: "100px" }}>
                      {t('code').toUpperCase()}
                    </label> */}
                      <input
                        name="ent_code"
                        type="text"
                        placeholder={t('code').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "200px" }}
                        value={entCode}
                        onChange={(e) => {
                          try {
                            handleSetEntityData("ent_code", e.target.value);
                            setEntCode(e.target.value);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                    </div>
                    :
                    <span className={`main-title status Critical`} style={{ fontWeight: "bold", fontSize: "14px" }}>
                      {`${t('accountNo').toUpperCase()} : ${entCode}`}
                    </span>
                }
                defaultExpanded={true}
              >
                <div className="form-details">
                  <div className="form-details-wrapper">
                    <div className="form-details-left">
                      <div className="input-item-with-label">
                        <label htmlFor="ent_type" className="form-dropdown-label" style={{ width: "80px" }}>
                          {t('type').toUpperCase()}
                        </label>
                        <Select
                          ref={entTypeRef}
                          id="ent_type"
                          name="ent_type"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="300px"
                          value={entType}
                          onChange={(selectedOption) => {
                            try {
                              handleSetEntityData("ent_type", selectedOption.value);
                              setEntType(selectedOption);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          options={entityTypeOptions}
                          isSearchable={true}
                          placeholder={t('type').toUpperCase()}
                          isDisabled={documentEnabled === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="ent_aent_code" className="form-dropdown-label" style={{ width: "80px" }}>
                          {t('category').toUpperCase()}
                        </label>
                        <Select
                          id="ent_aent_code"
                          name="ent_aent_code"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="300px"
                          value={entAentCode}
                          onChange={(selectedOption) => {
                            try {
                              handleSetEntityData("ent_aent_code", selectedOption.value);
                              setEntAentCode(selectedOption);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          options={entityCatgOptions}
                          isSearchable={true}
                          placeholder={t('category').toUpperCase()}
                          isDisabled={documentEnabled === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="ent_status" className="form-dropdown-label" style={{ width: "80px" }}>
                          {t('status').toUpperCase()}
                        </label>
                        <Select
                          id="ent_status"
                          name="ent_status"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="300px"
                          value={entStatus}
                          onChange={(selectedOption) => {
                            try {
                              handleSetEntityData("ent_status", selectedOption?.value);
                              setEntStatus(selectedOption);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          options={entityStatusOptions}
                          isSearchable={true}
                          placeholder={t('status').toUpperCase()}
                          isDisabled={true}
                        />
                      </div>
                      {entityData?.ent_person === "N" &&
                        <div className="input-item-with-label">
                          <label htmlFor="ent_sector"
                            className="form-input-label"
                            style={{ width: "80px" }}>
                            {t('sector').toUpperCase()}
                          </label>
                          {documentEnabled === "Y" ?
                            <Select
                              id="ent_sector"
                              name="ent_sector"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={definedSectors.find(option => option.value === entityData?.ent_sector) || null}
                              onChange={selectedOption => handleSetEntityData("ent_sector", selectedOption?.value)}
                              options={definedSectors}
                              isSearchable={true}
                              placeholder={t('sector')}
                              isDisabled={documentEnabled === "N"}
                            />
                            :
                            <input
                              name="ent_sector_xx"
                              type="text"
                              className="form-input-item"
                              style={{ width: "300px" }}
                              value={entityData?.ent_sector_xx}
                              onChange={(e) => handleSetEntityData("ent_sector", e.target.value)}
                              disabled={true}
                            />}
                        </div>}
                      {entityData?.ent_person === "N" &&
                        orgControls?.org_activate_kyc === "Y" &&
                        <div style={{ marginTop: "5px", marginLeft: "70px" }}>
                          <ToggleSwitch
                            id="ent_docs_verified"
                            value={entityData?.ent_docs_verified}
                            onChange={async (val) => {
                              try {
                                // console.log(`firing... val ... ${val}`);
                                // validate documents
                                if (val === "Y") {
                                  const docs = await newRequest.post("/allEntityCatg/find", { aent_code: entAentCode?.value });
                                  // console.log(`ValidationMessages messageData ${JSON.stringify(docs.data?.aent_required_docs, null, 2)}`);
                                  // console.log(`entityFilesData ${JSON.stringify(entityFilesData, null, 2)}`);
                                  if (docs.data?.aent_required_docs?.length > 0) {
                                    const missingDocsResult = validateMandatoryDocuments(docs.data?.aent_required_docs, entType?.value, entityFilesData);
                                    // console.log(`missingDocsResult ${JSON.stringify(missingDocsResult, null, 2)}`);
                                    if (missingDocsResult?.result_status === "error") {
                                      handleSetEntityData("ent_docs_verified", "N")
                                      setValidationMessagesResult(missingDocsResult);
                                      setIsConfirmDialogOpen(false);
                                      setValidationMsgDialog(true);
                                      return false;
                                    } else {
                                      handleSetEntityData("ent_docs_verified", val);
                                    }
                                  } else {
                                    handleSetEntityData("ent_docs_verified", val);
                                  }
                                }
                                handleSetEntityData("ent_docs_verified", val);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            label={t('docsVerified').toUpperCase()}
                            labelWidth="max-content"
                            labelPosition="end"
                            border="N"
                            style={{ width: "max-content" }}
                            disabled={documentEnabled === "N"}
                          />
                        </div>}
                      {entityData?.ent_person === "N" &&
                        ["investment"].includes(currentUser?.token_org_type) &&
                        <div className="input-item-with-label">
                          <label htmlFor="ent_investor_type"
                            className="form-input-label"
                            style={{ width: "80px" }}>
                            {t('investor').toUpperCase()}
                          </label>
                          {documentEnabled === "Y" ?
                            <Select
                              id="ent_investor_type"
                              name="ent_investor_type"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={investorTypes.find(option => option.value === entityData?.ent_investor_type) || null}
                              onChange={selectedOption => handleSetEntityData("ent_investor_type", selectedOption?.value)}
                              options={investorTypes}
                              isSearchable={true}
                              placeholder={t('investor')}
                              isDisabled={documentEnabled === "N"}
                            />
                            :
                            <input
                              name="ent_investor_type_xx"
                              type="text"
                              className="form-input-item"
                              style={{ width: "300px" }}
                              value={entityData?.ent_investor_type_xx}
                              onChange={(e) => handleSetEntityData("ent_investor_type", e.target.value)}
                              disabled={true}
                            />}
                        </div>}
                    </div>
                    <div className="form-details-right">
                      <div className="input-item-with-label">
                        <label htmlFor="ent_name" className="form-input-label" style={{ width: "100px" }}>
                          {t('name').toUpperCase()}
                        </label>
                        <input
                          name="ent_name"
                          type="text"
                          placeholder={t('name').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "300px" }}
                          value={entName}
                          onChange={(e) => {
                            try {
                              handleSetEntityData("ent_name", e.target.value);
                              setEntName(e.target.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={documentEnabled === "N"}
                          onBlur={(e) => {
                            if (e.target.value && !entAlias) {
                              setEntAlias(getFirstName(e.target.value));
                            }
                          }}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="ent_alias"
                          className="form-input-label"
                          style={{ width: "100px" }}>
                          {t('alias').toUpperCase()}
                        </label>
                        <input
                          name="ent_alias"
                          type="text"
                          placeholder={t('alias').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "200px" }}
                          value={entAlias}
                          onChange={(e) => {
                            try {
                              handleSetEntityData("ent_alias", e.target.value);
                              setEntAlias(e.target.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={documentEnabled === "N"}
                        />
                      </div>

                      {!["Corporate", "NGO"].includes(entType?.value) &&
                        <div className="input-item-with-label">
                          <label htmlFor="ent_tax_no" className="form-input-label" style={{ width: "100px" }}>
                            {t('taxNo').toUpperCase()}
                          </label>
                          <input
                            name="ent_tax_no"
                            type="text"
                            placeholder={t('taxNumber').toUpperCase()}
                            className="form-input-item"
                            style={{ width: "200px" }}
                            value={entTaxNo}
                            onChange={(e) => {
                              try {
                                handleSetEntityData("ent_tax_no", e.target.value);
                                setEntTaxNo(e.target.value);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            disabled={documentEnabled === "N"}
                          />
                        </div>}
                      {["Corporate", "NGO"].includes(entType?.value) &&
                        <div className="input-item-with-label" >
                          <label htmlFor="founded"
                            style={{ width: "100px" }}
                            className="form-input-label">
                            {t('founded').toUpperCase()}
                          </label>
                          <input
                            name="founded"
                            type="date"
                            placeholder={t('founded').toUpperCase()}
                            className="form-input-item"
                            style={{ width: "200px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                            value={entDob}
                            onChange={(e) => {
                              try {
                                const formattedDate = moment(e.target.value).format(
                                  "YYYY-MM-DD"
                                );
                                handleSetEntityData("ent_dob", formattedDate);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            disabled={documentEnabled === "N"}
                          />
                          <input
                            id="ent_age_xx"
                            name="ent_age_xx"
                            type="text"
                            placeholder="AGE"
                            value={entAgeXx}
                            className="form-input-item"
                            style={{
                              width: "100px",
                              height: "42px",
                              textAlign: "center",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              borderLeft: "none"
                            }}
                            disabled
                          />
                        </div>}
                      {entityData?.ent_person === "N" &&
                        <div className="input-item-with-label">
                          <label htmlFor="ent_sub_sector"
                            className="form-input-label"
                            style={{ width: "100px" }}>
                            {t('sub').toUpperCase()}
                          </label>
                          <Select
                            id="ent_sub_sector"
                            name="ent_sub_sector"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={definedSubSectors.find(option => option.value === entityData?.ent_sub_sector) || null}
                            onChange={selectedOption => handleSetEntityData("ent_sub_sector", selectedOption?.value)}
                            options={definedSubSectors}
                            isSearchable={true}
                            placeholder={t('sub')}
                            isDisabled={documentEnabled === "N"}
                          />
                        </div>}
                      {entityData?.ent_person === "N" &&
                        orgControls?.org_activate_aml === "Y" &&
                        <div className="input-item-with-label" style={{ marginTop: "5px" }}>
                          <label htmlFor="ent_aml_screened"
                            className="form-input-label"
                            style={{ width: "90px" }} />
                          <ToggleSwitch
                            id="ent_aml_screened"
                            value={entityData?.ent_aml_screened}
                            onChange={(val) => handleSetEntityData("ent_aml_screened", val)}
                            label={t('amlChecksDone').toUpperCase()}
                            labelWidth="max-content"
                            labelPosition="start"
                            border="N"
                            style={{ width: "max-content" }}
                            disabled={documentEnabled === "N" || !["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          />
                        </div>}
                    </div>
                  </div>
                  {["Corporate", "NGO"].includes(entType?.value) &&
                    <div className="form-details">
                      <hr className="separator-h" />
                      <span className="sub-title">{t('identifiers').toUpperCase()}</span>
                      <div className="form-details-wrapper">
                        <div className="form-details-left">
                          <div className="input-item-with-label">
                            <label htmlFor="ent_tax_no_corp" className="form-input-label" style={{ width: "80px" }}>
                              {t('taxNo').toUpperCase()}
                            </label>
                            <input
                              name="ent_tax_no_corp"
                              type="text"
                              placeholder={t('taxNumber').toUpperCase()}
                              className="form-input-item"
                              style={{ width: "300px" }}
                              value={entTaxNo}
                              onChange={(e) => {
                                try {
                                  handleSetEntityData("ent_tax_no", e.target.value);
                                  setEntTaxNo(e.target.value);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              disabled={documentEnabled === "N"}
                            />
                          </div>
                        </div>
                        <div className="form-details-right">
                          <div className="input-item-with-label">
                            <label htmlFor="ent_license_no" className="form-input-label" style={{ width: "max-content" }}>
                              {t('license').toUpperCase()}
                            </label>
                            <input
                              name="ent_license_no"
                              type="text"
                              placeholder={t('license').toUpperCase()}
                              className="form-input-item"
                              style={{ width: "300px" }}
                              value={entLicenseNo}
                              onChange={(e) => handleSetEntityData("ent_license_no", e.target.value)}
                              disabled={documentEnabled === "N"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
              </ExpandableComponent>
              <ExpandableComponent
                title={t('contactAndAddress').toUpperCase()}
                subtitle={""}
                defaultExpanded={true}
              >
                <div className="form-details">
                  <div className="form-details-wrapper">
                    <div className="form-details-left" style={{ gap: "5px" }}>
                      <div className="input-item-with-label">
                        <label htmlFor="ent_phone_no" className="form-dropdown-label" style={{ width: "80px" }}>
                          {t('phoneNo').toUpperCase()}
                        </label>
                        <input
                          name="ent_phone_no"
                          type="phone"
                          placeholder="Phone No"
                          className="form-input-item"
                          style={{ width: "300px" }}
                          value={entPhoneNo}
                          onChange={(e) => {
                            try {
                              handleSetEntityData("ent_phone_no", e.target.value);
                              setEntPhoneNo(e.target.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={documentEnabled === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="ent_postal_address" style={{ width: "80px", alignSelf: "flex-start" }}>
                          {t('postal').toUpperCase()}
                        </label>
                        <textarea
                          name="ent_postal_address"
                          type="text"
                          placeholder={t('postalAddress').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "300px", height: "max-content" }}
                          value={entPostalAddress}
                          rows={2}
                          onChange={(e) => {
                            try {
                              handleSetEntityData("ent_postal_address", e.target.value);
                              setEntPostalAddress(e.target.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={documentEnabled === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="region_code"
                          className="form-input-label"
                          style={{ width: "80px" }}>
                          {t('region').toUpperCase()}
                        </label>
                        {documentEnabled === "Y" ?
                          <Select
                            id="ent_region"
                            name="ent_region"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={definedRegions.find(option => option.value === entityData?.ent_region) || null}
                            onChange={selectedOption => handleSetEntityData("ent_region", selectedOption?.value)}
                            options={definedRegions}
                            isSearchable={true}
                            placeholder={t('region')}
                            isDisabled={documentEnabled === "N"}
                          /> :
                          <input
                            name="ent_region_xx"
                            type="text"
                            className="form-input-item"
                            style={{ width: "300px" }}
                            value={entityData?.ent_region_xx}
                            onChange={(e) => handleSetEntityData("ent_sector", e.target.value)}
                            disabled={true}
                          />}
                      </div>
                      {/* <div className="input-item-with-label">
                        <label htmlFor="ent_ward" className="form-dropdown-label" style={{ width: "80px" }}>{t('ward').toUpperCase()}</label>
                        <AsyncSelect
                          id="ent_ward"
                          name="ent_ward"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="300px"
                          value={entWard}
                          onChange={(selectedOption) => {
                            try {
                              handleSetEntityData(
                                "ent_ward",
                                selectedOption.value
                              );

                              setEntWard(selectedOption);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          loadOptions={(inputValue, callback) => fetchLocationsBySearch(inputValue, callback, "ward")}
                          isSearchable={true}
                          isDisabled={documentEnabled === "N"}
                          placeholder={t('ward').toUpperCase()}
                          noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                      </div> */}
                    </div>
                    <div className="form-details-right">
                      <div className="input-item-with-label">
                        <label htmlFor="ent_email" className="form-input-label" style={{ width: "70px" }}>
                          {t('email').toUpperCase()}
                        </label>
                        <input
                          name="ent_email"
                          type="email"
                          placeholder={t('email').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "300px" }}
                          value={entEmail}
                          onChange={(e) => {
                            try {
                              handleSetEntityData("ent_email", e.target.value);
                              setEntEmail(e.target.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={documentEnabled === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="ent_physical_address" className="form-dropdown-label" style={{ width: "70px", alignSelf: "flex-start" }}>
                          {t('physical').toUpperCase()}
                        </label>
                        <textarea
                          key={entityId}
                          name="ent_physical_address"
                          type="text"
                          placeholder={t('physicalAddress').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "300px", height: "max-content" }}
                          value={entPhysicalAddress}
                          rows={2}
                          onChange={(e) => {
                            try {
                              handleSetEntityData("ent_physical_address", e.target.value);
                              setEntPhysicalAddress(e.target.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={documentEnabled === "N"}
                        />
                      </div>
                      {entityData?.ent_type === "Individual" ?
                        <div className="input-item-with-label">
                          <label htmlFor="ent_nationality" className="form-dropdown-label" style={{ width: "100px" }}>{t('nationality').toUpperCase()}</label>
                          <AsyncSelect
                            id="ent_nationality"
                            name="ent_nationality"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={{
                              value: entityData?.ent_nationality,
                              label: entityData?.ent_nationality
                            }}
                            onChange={(selectedOption) => handleSetEntityData("ent_nationality", selectedOption?.value)}
                            loadOptions={(inputValue, callback) => fetchSystemCodes(inputValue, callback, "Nationalities")}
                            isSearchable={true}
                            isDisabled={documentEnabled === "N"}
                            placeholder={t('nationality')}
                            noOptionsMessage={() => "Type Minimum 1 Letter to Search"} />
                        </div>
                        :
                        <div className="input-item-with-label">
                          <label htmlFor="ent_website" className="form-dropdown-label" style={{ width: "70px" }}>{t('website').toUpperCase()}</label>
                          <input
                            name="ent_website"
                            type="text"
                            placeholder={t('website').toUpperCase()}
                            className="form-input-item"
                            style={{ width: "300px", height: "max-content" }}
                            value={entityData?.ent_website}
                            onChange={(e) => handleSetEntityData("ent_website", e.target.value)}
                            disabled={documentEnabled === "N"}
                          />
                        </div>}

                      {/* <div className="input-item-with-label">
                        <label htmlFor="ent_county" className="form-input-label" style={{ width: "100px" }}>
                          {t('county').toUpperCase()}
                        </label>
                        <AsyncSelect
                          id="ent_county"
                          name="ent_county"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="300px"
                          value={entCounty}
                          onChange={(selectedOption) => {
                            try {
                              handleSetEntityData(
                                "ent_county",
                                selectedOption.value
                              );
                              setEntCounty(selectedOption);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          loadOptions={(inputValue, callback) => fetchLocationsBySearch(inputValue, callback, "county")}
                          isSearchable={true}
                          isDisabled={documentEnabled === "N"}
                          placeholder={t('county').toUpperCase()}
                          noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                      </div> */}
                    </div>
                  </div>

                  <div className="input-item-with-label" style={{ width: "100%", paddingRight: "10px", margin: "10px 0px" }}>
                    <label
                      htmlFor="place"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('place').toUpperCase()}
                    </label>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "10px" }}>
                      <div style={{ display: "flex", flex: "1", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                        <span className='sub-title'>{entPlaceName || t('notSelected').toUpperCase()}</span>
                        {documentEnabled === "Y" &&
                          <CircularButton
                            currentTheme={currentTheme}
                            onClick={(e) => setPlacesDialogOpen(true)}
                            color="#3F51B5"
                            icon={<IoLocationSharp />}
                            width={"30px"}
                            height={"30px"} />}
                      </div>
                      <div className='google-place-wrapper' onClick={() => {
                        if (entLatitude && entLongitude && entPlaceName) { handleOpenMap(entLatitude, entLongitude) }
                      }}>
                        <span className='sub-title'>{`${t('latitude')} ${entLatitude || ""}`}</span>
                        <span className='sub-title'>{`${t('longitude')} ${entLongitude || ""}`}</span>
                      </div>
                    </div>
                  </div>
                  {entityData?.ent_person === "N" && <hr className="separator-h" />}
                  {entityData?.ent_person === "N" &&
                    <div className="form">
                      <div className="form-details-wrapper">
                        <div className="form-details-left">
                          <div className="input-item-with-label">
                            <label htmlFor="ent_tax_exempt" className="form-input-label" style={{ width: "70px" }} />
                            <ToggleSwitch
                              id="ent_tax_exempt"
                              value={entityData?.ent_tax_exempt}
                              onChange={(val) => handleSetEntityData("ent_tax_exempt", val)}
                              label={t('taxExempt').toUpperCase()}
                              labelWidth="max-content"
                              labelPosition="end"
                              disabled={documentEnabled === "N" || !["admin", "superadmin"].includes(currentUser.user_type_xx)}
                              border="N"
                              style={{
                                width: "max-content",
                              }}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label htmlFor="ent_tax_exempt_reason" className="form-input-label" style={{ width: "80px" }}>
                              {t('reason').toUpperCase()}
                            </label>
                            <Select
                              id="ent_tax_exempt_reason"
                              name="ent_tax_exempt_reason"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entTaxExemptReason}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData("ent_tax_exempt_reason", selectedOption.value);
                                  setEntTaxExemptReason(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={taxExemptReasons}
                              isSearchable={true}
                              placeholder={t('reason')}
                              isDisabled={documentEnabled === "N"}
                            />
                          </div>
                        </div>
                        <div className="form-details-right" >
                          <div className="input-item-with-label" style={{ alignSelf: "start", paddingLeft: "50px" }}>
                            <label htmlFor="ent_whatsapp" className="form-input-label" style={{ width: "70px" }} />
                            <ToggleSwitch
                              id="ent_whatsapp"
                              value={entityData?.ent_whatsapp}
                              onChange={(val) => handleSetEntityData("ent_whatsapp", val)}
                              label={t('activateWhatsApp').toUpperCase()}
                              labelWidth="max-content"
                              labelPosition="end"
                              disabled={documentEnabled === "N" || !["admin", "superadmin"].includes(currentUser.user_type_xx)}
                              border="N"
                              style={{
                                width: "max-content",
                              }}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label htmlFor="ent_whatsapp_no" className="form-input-label" style={{ width: "50px" }}>
                              {t('no').toUpperCase()}
                            </label>
                            <input
                              name="ent_whatsapp_no"
                              type="text"
                              placeholder={t('whatsAppNo').toUpperCase()}
                              className="form-input-item"
                              style={{ width: "300px" }}
                              value={entityData?.ent_whatsapp_no}
                              onChange={(e) => {
                                try {
                                  handleSetEntityData("ent_whatsapp_no", e.target.value);
                                  setEntWhatsappNo(e.target.value);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              disabled={documentEnabled === "N" || entWhatsapp === "N"}
                            />
                          </div>
                          {entWhatsapp === "Y" && <p>{t('whatsappDesc')}</p>}
                        </div>
                      </div>
                    </div>}
                </div>
              </ExpandableComponent>
              {/* key people */}
              {entCode &&
                (entAentCode.aent_layouts || [])?.find(item => item?.layout_key === "Key People") &&
                <ExpandableComponent
                  title={t('keyPeople').toUpperCase()}
                  subtitle={
                    documentEnabled === "Y" &&
                    <CircularButton
                      currentTheme={currentTheme}
                      onClick={async (e) => {
                        try {
                          const newRecord = {
                            _id: generateUniqueCode(),
                            person_name: "",
                            title: "",
                            phone_no: "",
                            email: "",
                            nationality: null,
                          }
                          setEntKeyPeople((prevData) => [...prevData, newRecord]);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      color="#0ea5a4"
                      icon={<MdAdd />}
                      width={"35px"}
                      height={"35px"} />}
                  defaultExpanded={entKeyPeople?.length > 0}
                >
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('nameAndTitle').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "350px" }}>
                              <span>{`${t('contacts').toUpperCase()}`}</span>
                            </TableCell>

                            {documentEnabled === "Y" &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{`${t('action').toUpperCase()}`}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {paginatedKeyPeople?.map((row, index) => (
                            <TableRow
                              key={index}
                              className={`${selectedKeyPerson?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              style={{ alignItems: "flex-start" }}
                              onClick={() => setSelectedKeyPerson(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {currentPageKeyPeople * rowsPerPageKeyPeople + index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", display: "flex", flexDirection: "column", gap: "5px", }}>
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`person_name_${row?._id}`}
                                      name={`person_name_${row?._id}`}
                                      type="text"
                                      placeholder={t('name')}
                                      value={row?.person_name}
                                      onChange={(e) => handleKeyPeopleChange(e, row?._id, 'person_name')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div> : <span className="sub-title">{`${row?.person_name} - ${row?.nationality}`}</span>}
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`title_${row?._id}`}
                                      name={`title_${row?._id}`}
                                      type="text"
                                      placeholder={t('title')}
                                      value={row?.title}
                                      onChange={(e) => handleKeyPeopleChange(e, row?._id, 'title')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div> : <span className="sub-title">{row?.title}</span>}
                                {documentEnabled === "Y" &&
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <AsyncSelect
                                      id={`nationality_${row?._id}`}
                                      name={`nationality_${row?._id}`}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="100%"
                                      height="36px"
                                      value={{
                                        value: row?.nationality,
                                        label: row?.nationality
                                      }}
                                      onChange={(selectedOption) => handleKeyPeopleChange(selectedOption, row?._id, 'nationality')}
                                      loadOptions={(inputValue, callback) => fetchSystemCodes(inputValue, callback, "Nationalities")}
                                      isSearchable={true}
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('nationality')}
                                      noOptionsMessage={() => "Type Minimum 1 Letter to Search"} />
                                  </div>}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "350px", display: "flex", flexDirection: "column", gap: "5px", }}>
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`email_${row?._id}`}
                                      name={`email_${row?._id}`}
                                      type="email"
                                      placeholder={t('email')}
                                      value={row?.email}
                                      onChange={(e) => handleKeyPeopleChange(e, row?._id, 'email')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div> : <span className="icon-value-row" > <MdAlternateEmail className="icon" /> <span>{row?.email}</span> </span>}
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`phone_no_${row?._id}`}
                                      name={`phone_no_${row?._id}`}
                                      type="text"
                                      placeholder={t('phoneNo')}
                                      value={row?.phone_no}
                                      onChange={(e) => handleKeyPeopleChange(e, row?._id, 'phone_no')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div> : <span className="icon-value-row" > <MdPhone className="icon" /> <span>{row?.phone_no}</span> </span>
                                }
                              </TableCell>

                              {documentEnabled === "Y" &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async (e) => {
                                      try {
                                        // const res = await newRequest.post("/fund/removeAssetClass",
                                        //   {
                                        //     fund_docid: fundDocId,
                                        //     asset_class: row?.asset_class
                                        //   });

                                        // if (res.data?.msg === "removed") {
                                        //   setAssetAllocation((prevData) =>
                                        //     prevData.filter(doc => doc?.asset_class !== row?.asset_class)
                                        //   );

                                        //   showToast("Deleted!", "success");
                                        // } else {
                                        //   showToast("Error deleting report!", "error");
                                        // }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"35px"}
                                    height={"35px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {entKeyPeople?.length > rowsPerPageKeyPeople &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPageKeyPeople}
                          onRowsPerPageChange={handleRowsPerPageKeyPeople}
                          component="div"
                          count={entKeyPeople?.length}
                          rows={entKeyPeople}
                          page={currentPageKeyPeople}
                          onPageChange={handlePageChangeKeyPeople}
                        />}
                    </TableContainer>
                  </div>
                </ExpandableComponent>}
              {/* end of key people */}
              {(entityData?.ent_type === "Individual" || entityData?.ent_person === "Y") &&
                <ExpandableComponent
                  title={t('personalInformation').toUpperCase()}
                  subtitle=""
                  defaultExpanded={true}
                >
                  <div className="form-details">
                    <div className="form-details-wrapper">
                      <div className="form-details-left">
                        <div className="input-item-with-label">
                          <label htmlFor="ent_surname"
                            className="form-dropdown-label"
                            style={{ width: "80px" }}>
                            {t('surname').toUpperCase()}
                          </label>
                          <input
                            name="ent_surname"
                            type="text"
                            placeholder="Surname"
                            className="form-input-item"
                            style={{ width: "300px" }}
                            value={entSurname}
                            onChange={(e) => {
                              try {
                                handleSetEntityData("ent_surname", e.target.value);
                                setEntSurname(e.target.value);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            disabled={documentEnabled === "N"}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label
                            htmlFor="ent_other_names"
                            className="form-dropdown-label"
                            style={{ width: "80px" }}
                          >
                            {t('otherNames').toUpperCase()}
                          </label>
                          <input
                            name="ent_other_names"
                            type="text"
                            placeholder="Other Names"
                            className="form-input-item"
                            style={{ width: "300px" }}
                            value={entOtherNames}
                            onChange={(e) => {
                              try {
                                handleSetEntityData("ent_other_names", e.target.value);
                                setEntOtherNames(e.target.value);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            disabled={documentEnabled === "N"}
                          />
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="ent_id_no"
                            className="form-dropdown-label"
                            style={{ width: "80px" }}>
                            {t('idNo').toUpperCase()}
                          </label>
                          <input
                            name="ent_id_no"
                            type="text"
                            placeholder="ID No"
                            className="form-input-item"
                            style={{ width: "300px" }}
                            value={entIdNo}
                            onChange={(e) => {
                              try {
                                handleSetEntityData("ent_id_no", e.target.value);
                                setEntIdNo(e.target.value);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            disabled={documentEnabled === "N"}
                          />
                        </div>
                      </div>
                      <div className="form-details-right">
                        <div className="input-item-with-label">
                          <label
                            htmlFor="ent_gender"
                            className="form-dropdown-label"
                          >
                            {t('gender').toUpperCase()}
                          </label>
                          <Select
                            id="ent_gender"
                            name="ent_gender"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={entGender}
                            onChange={(selectedOption) => {
                              try {
                                handleSetEntityData("ent_gender", selectedOption.value);

                                setEntGender(selectedOption);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            options={entityGenderOptions}
                            isSearchable={true}
                            placeholder={t('gender')}
                            isDisabled={documentEnabled === "N"}
                          />
                        </div>
                        <div className="input-item-with-label" >
                          <label htmlFor="ent_dob" className="form-input-label">
                            {t('dob').toUpperCase()}
                          </label>
                          <input
                            name="ent_dob"
                            type="date"
                            placeholder="D.O.B"
                            className="form-input-item"
                            style={{ width: "200px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                            value={entDob}
                            onChange={(e) => {
                              try {
                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                handleSetEntityData("ent_dob", formattedDate);
                                setEntDob(formattedDate);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            disabled={documentEnabled === "N"}
                          />
                          <input
                            id="ent_age_xx"
                            name="ent_age_xx"
                            type="text"
                            placeholder="AGE"
                            value={entAgeXx}
                            className="form-input-item"
                            style={{
                              width: "100px",
                              height: "42px",
                              textAlign: "center",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              borderLeft: "none"
                            }}
                            disabled
                          />
                        </div>
                        <div className="input-item-with-label" style={{ height: "42px", alignItems: "center" }}>
                          <ToggleSwitch
                            id="ent_disabled"
                            value={entityData?.ent_disabled}
                            onChange={(val) => handleSetEntityData("ent_disabled", val)}
                            label={t('disabledPerson').toUpperCase()}
                            labelWidth="max-content"
                            disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                            border="N"
                            style={{
                              width: "max-content",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {entityData?.ent_person === "N" && <hr className="separator-h" />}
                    {entityData?.ent_person === "N" && <span className="main-title">{t('employment')}</span>}
                    {entityData?.ent_person === "N" &&
                      <div className="form-details-wrapper">
                        <div className="form-details-left">
                          <div className="input-item-with-label">
                            <label
                              htmlFor="ent_employment_status"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}
                            >
                              {t('status').toUpperCase()}
                            </label>
                            <Select
                              id="ent_employment_status"
                              name="ent_employment_status"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entEmploymentStatus}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData("ent_employment_status", selectedOption.value);
                                  setEntEmploymentStatus(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={employmentStatuses}
                              isSearchable={true}
                              placeholder={t('status')}
                              isDisabled={documentEnabled === "N"}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="ent_premium_flag"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}
                            >
                              {t('flag').toUpperCase()}
                            </label>
                            <Select
                              id="ent_premium_flag"
                              name="ent_premium_flag"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entPremiumFlag}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData("ent_premium_flag", selectedOption.value);
                                  setEntPremiumFlag(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={premiumFlags}
                              isSearchable={true}
                              placeholder="Flag"
                              isDisabled={documentEnabled === "N"}
                            />
                          </div>
                          <div className="input-item-with-label" style={{ width: "100%" }}>
                            <label htmlFor="ent_monthly_income" className="form-input-label" style={{ width: "max-content" }}>
                              {t('monthlyIncome').toUpperCase()} [{currentUser?.currency_code_xx}]
                            </label>
                            <input
                              name="ent_monthly_income"
                              type="text"
                              placeholder="0.00"
                              className="form-input-item"
                              style={{ width: "220px", textAlign: "right" }}
                              value={entMonthlyIncome}
                              onChange={(e) => {
                                try {
                                  handleSetEntityData("ent_monthly_income", e.target.value);
                                  setEntMonthlyIncome(e.target.value);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              disabled={documentEnabled === "N"}
                              onBlur={handleMonthlyIncomeBlur}
                            />
                          </div>
                        </div>
                        <div className="form-details-right">
                          <div className="input-item-with-label">
                            <label htmlFor="ent_institution">{t('institution').toUpperCase()}</label>
                            <AsyncSelect
                              id="ent_institution"
                              name="ent_institution"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entInstitution}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData("ent_institution", selectedOption.value);
                                  setEntInstitution(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                              isSearchable={true}
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('institution').toUpperCase()}
                              noOptionsMessage={() => "Type Minimum 3 Letter to Search"} />
                          </div>
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label
                              htmlFor="ent_occupation"
                              className="form-dropdown-label"
                              style={{ width: "100px" }}
                            >
                              {t('occupation').toUpperCase()}
                            </label>
                            <AsyncSelect
                              id="ent_occupation"
                              name="ent_occupation"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entOccupation}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData("ent_occupation", selectedOption.value);
                                  setEntOccupation(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              loadOptions={(inputValue, callback) => fetchSystemCodes(inputValue, callback, "Occupations")}
                              isSearchable={true}
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('occupation').toUpperCase()}
                              noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                          </div>
                          <div className="input-item-with-label">
                            <label htmlFor="ent_monthly_premium" className="form-input-label" style={{ width: "max-content" }}>
                              {t('monthlyPremium').toUpperCase()} [{currentUser?.currency_code_xx}]
                            </label>
                            <input
                              name="ent_monthly_premium"
                              type="text"
                              placeholder="0.00"
                              className="form-input-item"
                              style={{ width: "200px", textAlign: "right" }}
                              value={entMonthlyPremium}
                              onChange={(e) => {
                                try {
                                  handleSetEntityData("ent_monthly_premium", e.target.value);
                                  setEntMonthlyPremium(e.target.value);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              disabled={documentEnabled === "N"}
                              onBlur={handleMonthlyPremiumBlur}
                            />
                          </div>
                        </div>
                      </div>}
                    {entityData?.ent_person === "N" && <hr className="separator-h" />}
                    <span className="main-title">{t('healthInformation')}</span>
                    <div className="form-details-wrapper">
                      <div className="form-details-left">
                        <div className="input-item-with-label">
                          <label
                            htmlFor="ent_smoke_flag"
                            className="form-dropdown-label"
                            style={{ width: "80px" }}
                          >
                            {t('smoke').toUpperCase()}
                          </label>
                          <Select
                            id="ent_smoke_flag"
                            name="ent_smoke_flag"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={entSmokeFlag}
                            onChange={(selectedOption) => {
                              try {
                                handleSetEntityData("ent_smoke_flag", selectedOption.value);
                                setEntSmokeFlag(selectedOption);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            options={smokingFlags}
                            isSearchable={true}
                            placeholder={t('smoke')}
                            isDisabled={documentEnabled === "N"}
                          />
                        </div>
                      </div>
                      <div className="form-details-right">
                        right
                      </div>
                    </div>
                  </div>
                </ExpandableComponent>}
              {/* organizations affiliations */}
              {entCode &&
                entityData?.ent_type !== "Individual" &&
                (entAentCode.aent_layouts || [])?.find(item => item?.layout_key === "Affiliations") &&
                <ExpandableComponent
                  title={t('affiliations').toUpperCase()}
                  subtitle={
                    <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "flex-end" }}>
                      {documentEnabled === "Y" &&
                        <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                          {/* <label htmlFor="relative_id">MANAGER</label> */}
                          <AsyncSelect
                            id="affiliation_id"
                            name="affiliation_id"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={selectedAffiliationToAdd}
                            onChange={(selectedOption) => {
                              try {
                                setSelectedAffiliationToAdd(selectedOption);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                            isSearchable={true}
                            isDisabled={documentEnabled === "N"}
                            placeholder="Affiliates"
                            noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                          <Select
                            id="affil_id"
                            name="affil_id"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={selectedAffiliationType}
                            onChange={(selectedOption) => {
                              try {
                                setSelectedAffiliationType(selectedOption);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            options={affiliationTypes}
                            isSearchable={true}
                            placeholder="Type"
                          />
                          <CustomLoadingButton
                            borderRadiusType="right"
                            height={"36px"}
                            currentTheme={currentTheme}
                            endIcon={<AddIcon />}
                            iconPosition="end"
                            onClick={async () => {
                              try {
                                if (!selectedAffiliationToAdd?.value) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Select entity!`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }

                                if (!selectedAffiliationType?.value) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Select relationship!`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }

                                const res = await newRequest.post(
                                  "/affiliation/add",
                                  {
                                    affil_main_ent_docid: entityData?._id,
                                    affil_main_ent_code: entityData?.ent_code,
                                    affil_related_ent_docid: selectedAffiliationToAdd?.ent_docid,
                                    affil_related_ent_code: selectedAffiliationToAdd?.value,
                                    affil_type: selectedAffiliationType?.value
                                  }
                                );

                                if (res.data?.msg === "added") {
                                  setAffiliations((prev) => [...prev, res.data?.doc]);
                                  setSelectedAffiliationToAdd(null);
                                  setSelectedAffiliationType(null);
                                  showToast("Added!", "success");
                                } else {
                                  showToast("Error adding affiliation!", "error");
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            {t('add')}
                          </CustomLoadingButton>
                        </div>}
                    </div>
                  }
                  defaultExpanded={affiliations?.length > 0}
                >
                  <div className="relationships-content">
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'space-between', padding: "0px 10px" }}>
                      {currentUser?.token_org_type === "regulator" && <span className="sub-title">{`${entityData?.affiliates_count} Affiliates`}</span>}
                      {currentUser?.token_org_type === "regulator" && <span className="sub-title">{`Total Expected Monthly Premium [${currentUser.currency_code_xx}] ${numeral(entityData?.affiliates_monthly_premium).format("0,0.00")}`}</span>}
                    </div>
                    {affiliations
                      ?.filter(
                        (row) =>
                          row?.affil_ent_name?.toLowerCase().includes(searchTermAffiliations.toLowerCase()) ||
                          row?.ent_phone_no?.toLowerCase().includes(searchTermAffiliations.toLowerCase()) ||
                          row?.ent_email?.toLowerCase().includes(searchTermAffiliations.toLowerCase())
                      )
                      .map((row) => (
                        <div key={row?.affil_ent_docid} className='single-relative'>
                          <div className="single-relative-left">
                            {row?.ent_photo_url ?
                              <img src={row?.ent_photo_url} alt="" className="logo" />
                              :
                              <InitialsAvatar
                                name={row?.ent_name}
                                size={60}
                                currentTheme={currentTheme}
                              />}
                          </div>
                          <div className="single-relative-right">
                            <div className="single-relative-header">
                              <span className='relative-name'>{row?.affil_ent_name}</span>
                              <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                <span className="relationship-type">{row?.affil_type}</span>
                                <h3 className={`status ${row?.affil_status}`}>{`Status : ${row?.affil_status}`}</h3>
                                {row?.affil_status === "Pending-Approval" &&
                                  getLimitValue("GB1008") === "Y" &&
                                  <CustomButtonSmallDarkBg
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {
                                        const res = await newRequest.put(`/affiliation/upd/${row?._id}`, { affil_status: "Active" });
                                        if (res.data?.msg === "updated") {
                                          const updatedDoc = res.data?.doc;
                                          setAffiliations((prev) => {
                                            return prev.map((param) => param._id === updatedDoc._id ? updatedDoc : param);
                                          });
                                          showToast("Updated!", "success");
                                        } else {
                                          showToast("Error updating affiliation!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    startIcon={<IoCheckmarkDoneOutline />}
                                    isCurrent={true}
                                  >
                                    {t('approve')}
                                  </CustomButtonSmallDarkBg>}
                                {row?.affil_status === "Active" &&
                                  getLimitValue("GB1009") === "Y" &&
                                  <CustomButtonSmallDarkBg
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {

                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}
                                    startIcon={<MdEdit />}
                                    isCurrent={true}
                                  >
                                    {t('edit')}
                                  </CustomButtonSmallDarkBg>}
                                {row?.affil_status === "Active" &&
                                  getLimitValue("GB1010") === "Y" &&
                                  <CustomButtonSmallDarkBg
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {

                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}
                                    startIcon={<MdClose />}
                                    isCurrent={true}
                                  >
                                    {t('remove')}
                                  </CustomButtonSmallDarkBg>}
                              </div>
                            </div>
                            <div className="relative-phone-row">
                              <span className="relative-phone-details f3" >
                                <MdEmail className="icon" /> <span>{row?.ent_email}</span>
                              </span>
                              <span className="relative-phone-details f1">
                                <MdPhone className="icon" /> <span>{row?.ent_phone_no}</span>
                              </span>
                              <span className="relative-phone-details f1"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEntityNavigate(row?.affil_ent_docid)}>
                                <MdNumbers className="icon" /> <span>{row?.affil_ent_code}</span>
                              </span>
                            </div>

                            <div className="relative-phone-row" style={{ justifyContent: "flex-end", marginTop: "10px", paddingRight: "10px" }} >
                              <span className="sub-title">{`Monthly Premium [${currentUser.currency_code_xx}] ${numeral(row?.ent_monthly_premium).format("0,0.00")}`}</span>
                            </div>

                          </div>
                        </div>
                      ))}
                  </div>
                </ExpandableComponent>}
              {/* other applications mapping */}
              {entCode &&
                (entAentCode.aent_layouts || [])?.find(item => item?.layout_key === "Other Apps") &&
                <ExpandableComponent
                  title={t('otherAppsMapping').toUpperCase()}
                  subtitle={
                    <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "flex-end" }}>
                      {documentEnabled === "Y" &&
                        <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                          <Select
                            id="app_id"
                            name="app_id"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="250px"
                            value={selectedOtherApp}
                            onChange={(selectedOption) => setSelectedOtherApp(selectedOption)}
                            options={otherAppTypes}
                            isSearchable={true}
                            placeholder={t('app')}
                          />
                          <div className="input-item-with-label">
                            <input
                              name="otherAppCode"
                              type="text"
                              placeholder={t('code')}
                              className="form-input-item"
                              style={{ width: "150px" }}
                              value={otherAppCode}
                              onChange={(e) => setOtherAppCode(e.target.value)}
                            />
                          </div>

                          <CircularButton
                            currentTheme={currentTheme}
                            onClick={async () => {
                              try {
                                if (!selectedOtherApp?.value) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Select application!`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }
                                if (!otherAppCode) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Enter code!`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }
                                setIsProcessing(true);
                                const res = await newRequest.post(
                                  "/allEntity/addOtherAppMapping",
                                  {
                                    entity_docid: entityData?._id,
                                    app_code: selectedOtherApp?.value,
                                    app_ent_code: otherAppCode
                                  }
                                );
                                logData("addOtherAppMapping", res.data);
                                setIsProcessing(false);
                                if (res.data?.msg === "added") {
                                  setEntOtherApps((prev) => [...prev, res.data?.doc]);
                                  setSelectedOtherApp(null);
                                  setOtherAppCode(null);
                                  showToast(t('added'), "success");
                                } else if (res.data?.msg === "updated") {
                                  const updatedDoc = res.data?.doc;
                                  setEntOtherApps((prevData) => { return prevData.map((app) => app?.app_code === otherAppCode ? updatedDoc : app); });
                                  setSelectedOtherApp(null);
                                  setOtherAppCode(null);
                                  showToast(t('added'), "success");
                                } else {
                                  showToast("error adding mapping!", "error");
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            color="#0ea5a4"
                            icon={<MdAdd />}
                            width={"35px"}
                            height={"35px"} />
                        </div>}
                    </div>
                  }
                  defaultExpanded={entOtherApps?.length > 0}
                >
                  <div className="relationships-content">
                    {entOtherApps
                      ?.filter(
                        (row) =>
                          row?.app_code?.toLowerCase().includes(searchTermApps.toLowerCase()) ||
                          row?.app_ent_code?.toLowerCase().includes(searchTermApps.toLowerCase())
                      )
                      .map((row) => (
                        <div key={row?.affil_ent_docid} className='other-apps-wrapper'>
                          <div className="other-apps-left">
                            <span className="normal-title">{`${t('application')} : ${row?.app_code}`}</span>
                            <span className="normal-title">{`${t('code')} : ${row?.app_ent_code}`} </span>
                          </div>
                          {documentEnabled === "Y" &&
                            <div className="other-apps-right">
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={async () => {
                                  try {
                                    setIsProcessing(true);
                                    const res = await newRequest.post(
                                      "/allEntity/deleteOtherAppMapping",
                                      {
                                        entity_docid: entityData?._id,
                                        app_code: row?.app_code,
                                        app_ent_code: row?.app_ent_code
                                      }
                                    );
                                    setIsProcessing(false);
                                    if (res.data?.msg === "deleted") {
                                      setEntOtherApps((prev) => prev.filter(param => param.app_code !== row?.app_code));
                                      setSelectedOtherApp(null);
                                      setOtherAppCode(null);
                                      showToast(t('deleted'), "success");
                                    } else {
                                      showToast(`error deleting mapping!`, "error");
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                color="#E53935"
                                icon={<MdDelete />}
                                width={"30px"}
                                height={"30px"} />
                            </div>}
                        </div>
                      ))}
                  </div>
                </ExpandableComponent>}

              {/* relationships for the entity */}
              {/* Show More Info Once Saved */}
              {entCode &&
                (entAentCode.aent_layouts || [])?.find(item => item?.layout_key === "Household") &&
                (entityData?.ent_type === "Individual" || entityData?.ent_person === "Y") && <>
                  <ExpandableComponent
                    title={t('household').toUpperCase()}
                    subtitle={documentEnabled === "Y" &&
                      <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px", justifyContent: "flex-end" }}>
                        {/* <label htmlFor="relative_id">MANAGER</label> */}
                        <AsyncSelect
                          id="relative_id"
                          name="relative_id"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="250px"
                          value={selectedRelativeToAdd}
                          onChange={(selectedOption) => setSelectedRelativeToAdd(selectedOption)}
                          loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                          isSearchable={true}
                          isDisabled={documentEnabled === "N"}
                          placeholder={t('relative').toUpperCase()}
                          noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                        <Select
                          id="role_id"
                          name="role_id"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="150px"
                          value={selectedRelaType}
                          onChange={(selectedOption) => setSelectedRelaType(selectedOption)}
                          options={relationshipTypes}
                          isSearchable={true}
                          placeholder={t('type').toUpperCase()}
                        />
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={async () => {
                            try {
                              if (!selectedRelativeToAdd?.value) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`Select entity!`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              if (!selectedRelaType?.value) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`Select relationship!`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              const res = await newRequest.post(
                                "/allEntityRela/add",
                                {
                                  rela_main_ent_docid: entityData?._id,
                                  rela_main_ent_code: entityData?.ent_code,
                                  rela_related_ent_docid: selectedRelativeToAdd?.ent_docid,
                                  rela_related_ent_code: selectedRelativeToAdd?.value,
                                  rela_type: selectedRelaType?.value,
                                  rela_main_ent_gender: entGender?.value,
                                }
                              );

                              if (res.data?.msg === "added") {
                                setRelationships((prev) => [...prev, res.data?.doc]);
                                setSelectedRelaType(null);
                                setSelectedRelativeToAdd(null);
                                showToast("Added!", "success");
                              } else {
                                showToast("Error adding relationship!", "error");
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          color="#0ea5a4"
                          icon={<MdAdd />}
                          width={"35px"}
                          height={"35px"} />
                      </div>}
                    defaultExpanded={true}
                  >
                    <div className="relationships-content">
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'space-between', padding: "0px 10px" }}>
                        <span className="sub-title">{`${entityData?.household_males} ${t('male')}`}</span>
                        <span className="sub-title">{`${entityData?.household_females} ${t('female')}`}</span>
                        <span className="sub-title">{`${entityData?.household_others} ${t('others')}`}</span>
                        <span className="sub-title">{`${t('totalHouseholdIncome')} [${currentUser.currency_code_xx}] ${numeral(entityData?.household_monthly_income).format("0,0.00")}`}</span>
                      </div>
                      {relationships
                        ?.filter(
                          (row) =>
                            row?.rela_ent_name?.toLowerCase().includes(searchTermRelationships.toLowerCase()) ||
                            row?.ent_phone_no?.toLowerCase().includes(searchTermRelationships.toLowerCase()) ||
                            row?.ent_email?.toLowerCase().includes(searchTermRelationships.toLowerCase())
                        )
                        .map((row) => (
                          <div key={row?.rela_ent_docid} className='single-relative'>
                            <div className="single-relative-left">
                              {row?.ent_photo_url ?
                                <img src={row?.ent_photo_url} alt="" className="logo" />
                                :
                                <InitialsAvatar
                                  name={row?.ent_name}
                                  size={60}
                                  currentTheme={currentTheme}
                                />}
                            </div>
                            <div className="single-relative-right">
                              <div className="single-relative-header">
                                <span className='relative-name'>{row?.rela_ent_name}</span>
                                <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                  <span className="relationship-type">{row?.rela_type} - {row?.rela_age_xx}</span>
                                  <h3 className={`status ${row?.rela_status}`}>{`Relationship Status : ${row?.rela_status}`}</h3>
                                  {row?.rela_status === "Pending-Approval" &&
                                    getLimitValue("GB1008") === "Y" &&
                                    <CustomButtonSmallDarkBg
                                      currentTheme={currentTheme}
                                      onClick={async () => {
                                        try {
                                          const res = await newRequest.put(`/allEntityRela/upd/${row?._id}`, { rela_status: "Active" });
                                          if (res.data?.msg === "updated") {
                                            const updatedDoc = res.data?.doc;
                                            setRelationships((prev) => {
                                              return prev.map((param) =>
                                                param._id === updatedDoc._id ? updatedDoc : param
                                              );
                                            });
                                            showToast("Updated!", "success");
                                          } else {
                                            showToast("Error updating relationship!", "error");
                                          }
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      startIcon={<IoCheckmarkDoneOutline />}
                                      isCurrent={true}
                                    >
                                      {t('approve')}
                                    </CustomButtonSmallDarkBg>}
                                  {row?.rela_status === "Active" &&
                                    getLimitValue("GB1009") === "Y" &&
                                    <CustomButtonSmallDarkBg
                                      currentTheme={currentTheme}
                                      onClick={async () => {
                                        try {

                                        } catch (error) {
                                          console.log(error)
                                        }
                                      }}
                                      startIcon={<MdEdit />}
                                      isCurrent={true}
                                    >
                                      {t('edit')}
                                    </CustomButtonSmallDarkBg>}
                                  {row?.rela_status === "Active" &&
                                    getLimitValue("GB1010") === "Y" &&
                                    <CustomButtonSmallDarkBg
                                      currentTheme={currentTheme}
                                      onClick={async () => {
                                        try {

                                        } catch (error) {
                                          console.log(error)
                                        }
                                      }}
                                      startIcon={<MdClose />}
                                      isCurrent={true}
                                    >
                                      {t('remove')}
                                    </CustomButtonSmallDarkBg>}
                                </div>
                              </div>
                              <div className="relative-phone-row">
                                <span className="relative-phone-details f3" >
                                  <MdEmail className="icon" /> <span>{row?.ent_email}</span>
                                </span>
                                <span className="relative-phone-details f1">
                                  <MdPhone className="icon" /> <span>{row?.ent_phone_no}</span>
                                </span>
                                <span className="relative-phone-details f1">
                                  {!["Male", "Female"].includes(row?.ent_gender) && <span className="relative-phone-details"><TbGenderEpicene className="icon" /> {row?.ent_gender}</span>}
                                  {["Male"].includes(row?.ent_gender) && <span className="relative-phone-details"><PiGenderMaleBold className="icon" /> {row?.ent_gender}</span>}
                                  {["Female"].includes(row?.ent_gender) && <span className="relative-phone-details"><PiGenderFemaleBold className="icon" /> {row?.ent_gender}</span>}
                                </span>
                                <span className="relative-phone-details f1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleEntityNavigate(row?.rela_ent_docid)}>
                                  <MdNumbers className="icon" /> <span>{row?.rela_ent_code}</span>
                                </span>
                              </div>
                              {row?.ent_type === "Individual" && <div className="relative-phone-row" style={{ justifyContent: "flex-end", marginTop: "10px", paddingRight: "10px" }} >
                                <span className="sub-title">{`${t('monthlyIncome')} [${currentUser.currency_code_xx}] ${numeral(row?.ent_monthly_income).format("0,0.00")}`}</span>
                              </div>}
                              {/* {row?.is_valid_relationship && <span className="error-text">{`! Check if this relationship is correct`}</span>} */}
                            </div>
                          </div>
                        ))}
                    </div>
                  </ExpandableComponent>
                  {entCode &&
                    entityData?.ent_type !== "Individual" &&
                    <>
                      <ExpandableComponent
                        title={t('accountManagers').toUpperCase()}
                        subtitle={<div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                          <label htmlFor="admin_id">{t('manager').toUpperCase()}</label>
                          <Select
                            id="admin_id"
                            name="admin_id"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="250px"
                            value={selectedManagerToAdd}
                            onChange={(selectedOption) => {
                              try {
                                setSelectedManagerToAdd(selectedOption);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            options={users}
                            isSearchable={true}
                            placeholder={t('manager').toUpperCase()}
                          />
                          <Select
                            id="role_id"
                            name="role_id"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="150px"
                            value={selectedRoleToAdd}
                            onChange={(selectedOption) => setSelectedRoleToAdd(selectedOption)}
                            options={userRoles}
                            isSearchable={true}
                            placeholder={t("role")}
                          />
                          <CustomLoadingButton
                            borderRadiusType="right"
                            currentTheme={currentTheme}
                            endIcon={<AddIcon />}
                            iconPosition="end"
                            onClick={handleAddManager}
                          >
                            {t('add')}
                          </CustomLoadingButton>
                        </div>}

                        defaultExpanded={true}
                      >
                        {/* account managers */}
                        <div className="org-admins-wrapper">
                          {accountManagers.length > 0 && (
                            <>
                              {accountManagers?.map((row, index) => (
                                <div key={row._id} className="single-item">
                                  <span
                                    style={{
                                      alignContent: "flex-start",
                                      fontWeight: "bold",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {index + 1}.
                                  </span>
                                  <div className="user">
                                    {row?.manager_by_photo_url_xx ?
                                      <img src={row?.manager_by_photo_url_xx} alt="" className="logo" /> : <CiImageOn style={{ width: "30px", height: "30px" }} />}
                                    <div className="user-org-view">
                                      <span className="user-full-name">
                                        {row.manager_by_name_xx}
                                      </span>
                                      <span className="user-role-name">
                                        {row.manager_role_xx}
                                      </span>
                                    </div>
                                    {["admin", "superadmin"].includes(currentUser.user_type_xx) && <Tooltip
                                      title={`Remove ${row.manager_by_name_xx} as ${row.manager_role_xx} from ${entName}`}
                                      placement="right"
                                    >
                                      <IoClose
                                        size={24}
                                        style={{
                                          borderRadius: "5px",
                                          padding: "3px",
                                          cursor: "pointer",
                                          color: "rgba(172, 33, 9)",
                                          backgroundColor: "rgba(172, 33, 9, 0.5)",
                                        }}
                                        onClick={() => {
                                          try {
                                            const action_text = `Remove ${row.manager_by_name_xx} as ${row.manager_role_xx} from ${entName}?`;
                                            setObjectToAction({
                                              object_id: row._id,
                                              action_text: action_text,
                                            });
                                            setConfirmDialogAction("removeManager");
                                            setIsConfirmDialogOpen(true);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      />
                                    </Tooltip>}
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      </ExpandableComponent>
                    </>}
                </>}
              {/* FACILITY WARDS AND BEDS */}
              {entCode &&
                entityData?.ent_type !== "Individual" &&
                entAentCode?.value !== "Partner" &&
                <>
                  {currentUser?.token_org_type === "regulator" &&
                    <ExpandableComponent
                      title={currentUser?.token_org_type}
                      subtitle={
                        <ToggleSwitch
                          id="ent_24_hours"
                          value={entityData?.ent_24_hours}
                          onChange={(val) => handleSetEntityData("ent_24_hours", val)}
                          label={`OPERATING 24 HOURS`}
                          labelWidth="max-content"
                          disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          border="N"
                          style={{
                            width: "max-content",
                          }}
                        />
                      }

                      defaultExpanded={true}
                    >
                      <motion.div
                        className="facility-wrapper"
                        style={{ padding: "5px 10px" }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { duration: 1 } }}
                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                        <hr className="separator-h" />
                        <span className="sub-title" style={{ alignSelf: "center", margin: "5px 0px" }}>SUMMARY</span>
                        <div className="facility-summary" style={{ padding: "0px 10px" }}>
                          <span style={{ display: "flex", flexDirection: "column", gap: "5px", flexWrap: "wrap", width: "100%", alignItems: "center" }}>
                            <h1 className="sub-title">{entityData?.facility_wards_count_xx > 1 ? `${entityData?.facility_wards_count_xx} Wards` : `${entityData?.facility_wards_count_xx} Ward`}</h1>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setCurrentAction("addWard");
                                  setIsAddDialogTitle("Add Ward");
                                  setIsAddDialogOpened(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              color="#0ea5a4"
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                          <span style={{ display: "flex", flexDirection: "column", gap: "5px", flexWrap: "wrap", width: "100%", alignItems: "center" }}>
                            <h1 className="sub-title">{entityData?.facility_bed_count_xx > 1 ? `${entityData?.facility_bed_count_xx} Beds` : `${entityData?.facility_bed_count_xx} Bed`}</h1>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setCurrentAction("addBed");
                                  setIsAddDialogTitle("Add Bed");
                                  setIsAddDialogOpened(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                          <span style={{ display: "flex", flexDirection: "column", gap: "5px", flexWrap: "wrap", width: "100%", alignItems: "center" }}>
                            <h1 className="sub-title">{entFacilityTheatres?.length > 1 ? `${entFacilityTheatres?.length} Theatres` : `${entFacilityTheatres?.length} Theatre`}</h1>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setCurrentAction("addTheatre");
                                  setIsAddDialogTitle("Add Theatre");
                                  setIsAddDialogOpened(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              color="#0ea5a4"
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                          <span style={{ display: "flex", flexDirection: "column", gap: "5px", flexWrap: "wrap", width: "100%", alignItems: "center" }}>
                            <h1 className="sub-title">{entPharmacies?.length > 1 ? `${entPharmacies?.length} Pharmacies` : `${entPharmacies?.length} Pharmacy`}</h1>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setCurrentAction("addPharmacy");
                                  setIsAddDialogTitle("Add Pharmacy");
                                  setIsAddDialogOpened(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              color="#0ea5a4"
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                          <span style={{ display: "flex", flexDirection: "column", gap: "5px", flexWrap: "wrap", width: "100%", alignItems: "center" }}>
                            <h1 className="sub-title">{entAmbulances?.length > 1 ? `${entAmbulances?.length} Ambulances` : `${entAmbulances?.length} Ambulance`}</h1>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setCurrentAction("addAmbulance");
                                  setIsAddDialogTitle("Add Ambulance");
                                  setIsAddDialogOpened(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              color="#0ea5a4"
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                          <span style={{ display: "flex", flexDirection: "column", gap: "5px", flexWrap: "wrap", width: "100%", alignItems: "center" }}>
                            <h1 className="sub-title">{entAccreditations?.length > 1 ? `${entAccreditations?.length} Accreditations` : `${entAccreditations?.length} Accreditation`}</h1>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setCurrentAction("addAccreditation");
                                  setIsAddDialogTitle("Add Accreditation");
                                  setIsAddDialogOpened(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              color="#0ea5a4"
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                        </div>
                        <hr className="separator-h" />
                        <div className="facility-summary" style={{ margin: "5px 0px" }}>
                          <FormGroup row sx={{ display: "flex", gap: 1, p: 1 }}>
                            {daysOfWeek.map((day) => (
                              <FormControlLabel
                                key={day}
                                control={
                                  <Checkbox
                                    value={day}
                                    checked={entOperatingDays.includes(day)}
                                    onChange={handleDayChange}
                                  />
                                }
                                label={day}
                              />
                            ))}
                          </FormGroup>
                          {/* <div style={{
                            display: "flex",
                            padding: "4px 10px",
                            width: "100%",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "space-between"
                          }}>
                            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
                              <label key={day} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <input
                                  type="checkbox"
                                  value={day}
                                  checked={entOperatingDays.includes(day)}
                                  onChange={handleDayChange}
                                  style={{ marginRight: "5px" }}
                                />
                                {day}
                              </label>
                            ))}
                          </div> */}
                        </div>
                        {ent24Hours === "N" &&
                          <div className="facility-summary" style={{ margin: "5px 0px" }}>
                            <div className="input-item-with-label" style={{ width: "100%", alignItems: "center", justifyContent: "center" }}>
                              <label htmlFor="ent_facility_level"
                                className="form-dropdown-label"
                                style={{ width: "80px" }}>Opening</label>
                              <input
                                name="ent_opening_time"
                                type="time"
                                placeholder="-- : --"
                                className="form-input-item"
                                style={{ width: "107px" }}
                                value={entOpeningTime}
                                onChange={(e) => {
                                  try {
                                    const newTime = e.target.value;
                                    setEntOpeningTime(newTime);
                                    handleSetEntityData("ent_opening_time", newTime);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                disabled={documentEnabled === "N"}
                              />
                              <label htmlFor="ent_closing_time"
                                className="form-dropdown-label"
                                style={{ width: "80px" }}>{t('closing')}</label>
                              <input
                                name="ent_closing_time"
                                type="time"
                                placeholder="-- : --"
                                className="form-input-item"
                                style={{ width: "107px" }}
                                value={entClosingTime}
                                onChange={(e) => {
                                  try {
                                    const newTime = e.target.value;
                                    setEntClosingTime(newTime);
                                    handleSetEntityData("ent_closing_time", newTime);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                disabled={documentEnabled === "N"}
                              />
                            </div>
                          </div>}
                        <hr className="separator-h" />
                        <div className="facility-summary">
                          <div className="input-item-with-label">
                            <label htmlFor="ent_facility_level"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}>
                              LEVEL
                            </label>
                            <Select
                              id="ent_facility_level"
                              name="ent_facility_level"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entFacilityLevel}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData(
                                    "ent_facility_level",
                                    selectedOption.value
                                  );

                                  setEntFacilityLevel(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={facilityLevels}
                              isSearchable={true}
                              placeholder="Level"
                              isDisabled={documentEnabled === "N"}
                            />
                          </div>

                          <div className="input-item-with-label">
                            <label htmlFor="ent_ownership"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}>
                              OWNERSHIP
                            </label>
                            <Select
                              id="ent_ownership"
                              name="ent_ownership"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={entOwnership}
                              onChange={(selectedOption) => {
                                try {
                                  handleSetEntityData(
                                    "ent_ownership",
                                    selectedOption.value
                                  );

                                  setEntOwnership(selectedOption);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={ownershipTypes}
                              isSearchable={true}
                              placeholder="Ownership"
                              isDisabled={documentEnabled === "N"}
                            />
                          </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", width: "100%", padding: "10px", paddingLeft: "90px", gap: "10px" }}>
                          <p className="sub-title">{entFacilityLevel?.desc}</p>
                        </div>

                        {/* APPLICABLE PLANS */}
                        {entApplicablePlans?.length > 0 && <span style={{ marginTop: "10px" }} />}
                        {entApplicablePlans?.length > 0 && <hr className="separator-h" style={{ marginTop: "10px" }} />}
                        {entApplicablePlans?.length > 0 && <span style={{ marginTop: "5px" }} />}
                        <div style={{ display: "flex", flexDirection: 'row', width: "100%", alignItems: 'center', gap: '5px' }}>
                          <span className="sub-title">{entApplicablePlans?.length === 1 ? `${entApplicablePlans?.length} PLAN` : `${entApplicablePlans?.length} PLANS`}</span>
                          <CircularButton currentTheme={currentTheme}
                            onClick={async () => {
                              try {
                                await fetchAvailablePlans();
                                setCurrentAction("addPlan");
                                setIsAddDialogTitle("Add Plan");
                                setIsAddDialogOpened(true);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            color="#0ea5a4"
                            icon={<MdAdd />}
                            width={"35px"}
                            height={"35px"} />
                        </div>
                        {entApplicablePlans?.length > 0 &&
                          <div className="facility-content">
                            <div className="table-content">
                              <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                  <TableBody className="tablebody">
                                    {entApplicablePlans?.map((plan, index) => (
                                      <TableRow
                                        key={plan?._id}
                                        className={`${selectedPlan?._id === plan._id ? "tablerow current" : "tablerow"}`}
                                        onClick={() => {
                                          try {
                                            setSelectedPlan(plan);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                          {index + 1}
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                          <span className="sub-title">{plan?.plan_name}</span>
                                        </TableCell>
                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                          <TableCell className="table-cell center" style={{ maxWidth: "60px", }}>
                                            <CircularButton
                                              currentTheme={currentTheme}
                                              onClick={() => {
                                                try {
                                                  if (!["superadmin"].includes(currentUser.user_type_xx)) {
                                                    setNotifyDialogTitle("Note!");
                                                    setNotifyDialogText(`Only Super Admins can remove a plan!`);
                                                    setIsNotifyDialogOpen(true);
                                                    return;
                                                  }
                                                  setObjectToAction({
                                                    object_id: plan?.plan_code,
                                                    action_text: `Remove ${plan?.plan_name}?`,
                                                  });
                                                  setConfirmDialogAction("deletePlan");
                                                  setIsConfirmDialogOpen(true);
                                                } catch (error) {
                                                  console.log(error);
                                                }
                                              }}
                                              color="#E53935"
                                              icon={<MdDelete />}
                                              width={"35px"}
                                              height={"35px"} />
                                          </TableCell>}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </div>}

                        {/* WARDS & BEDS */}
                        <div className="facility-content">
                          <div className="grid-container">
                            {entFacilityWards?.map((ward) => (
                              <ExpandableComponent
                                key={ward?._id}
                                title={ward?.ward_name}
                                subtitle={
                                  <div style={{ display: "flex", gap: "10px", alignItems: "center", flexDirection: "row", }}>
                                    <span className="sub-title">{`Ward # ${ward?.ward_no}`}</span>
                                    <div style={{ display: "flex", gap: "1px", alignItems: "center", flexDirection: "row" }}>
                                      <CustomLoadingButton
                                        borderRadiusType="left"
                                        currentTheme={currentTheme}
                                        endIcon={<AddIcon />}
                                        height={"32px"}
                                        iconPosition="end"
                                        onClick={async () => {
                                          try {

                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        Add Bed
                                      </CustomLoadingButton>
                                      <CustomLoadingButton
                                        borderRadiusType="right"
                                        currentTheme={currentTheme}
                                        endIcon={<MdDelete />}
                                        height={"32px"}
                                        iconPosition="end"
                                        onClick={() => {
                                          try {

                                            if (!["superadmin"].includes(currentUser.user_type_xx)) {
                                              setNotifyDialogTitle("Note!");
                                              setNotifyDialogText(`Only Super Admins can remove a ward!`);
                                              setIsNotifyDialogOpen(true);
                                              return;
                                            }

                                            const action_text = `Remove ${ward?.ward_name}?`;
                                            setObjectToAction({
                                              object_id: ward?._id,
                                              action_text: action_text,
                                            });

                                            setConfirmDialogAction("deleteWard");
                                            setIsConfirmDialogOpen(true);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        Delete Ward
                                      </CustomLoadingButton>
                                    </div>
                                  </div>}

                                defaultExpanded={false}
                              >
                                <div className="beds-grid">
                                  {ward?.ward_beds?.map((bed) => (
                                    <BedCard key={bed?._id} bed={bed} currentTheme={currentTheme} />
                                  ))}
                                </div>
                              </ExpandableComponent>
                            ))}
                          </div>
                        </div>
                        {/* THEATRES */}
                        {entFacilityTheatres?.length > 0 && <span style={{ marginTop: "10px" }} />}
                        {entFacilityTheatres?.length > 0 && <hr className="separator-h" style={{ marginTop: "10px" }} />}
                        {entFacilityTheatres?.length > 0 && <span style={{ marginTop: "5px" }} />}
                        {entFacilityTheatres?.length > 0 && <span className="sub-title">{entFacilityTheatres?.length === 1 ? `${entFacilityTheatres?.length} THEATRE` : `${entFacilityTheatres?.length} THEATRES`}</span>}
                        {entFacilityTheatres?.length > 0 &&
                          <div className="facility-content">
                            <div className="table-content">
                              <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                  <TableBody className="tablebody">
                                    {entFacilityTheatres?.map((theatre, index) => (
                                      <TableRow
                                        key={theatre._id}
                                        className={`${selectedTheatre?._id === theatre._id ? "tablerow current" : "tablerow"}`}
                                        onClick={() => {
                                          try {
                                            setSelectedTheatre(theatre);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                          {index + 1}
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", width: "100%" }}>
                                            <span className="sub-title">{theatre?.theatre_name}</span>
                                            <CustomButtonSmallDarkBg
                                              borderRadiusType="right"
                                              currentTheme={currentTheme}
                                              endIcon={<AddIcon />}
                                              iconPosition="end"
                                              onClick={async () => {
                                                // fetch type of equipments
                                                await fetchTheatreEquipments();
                                                setSelectedTheatre(theatre);
                                                setIsAddDialogTitle("Add Equipment");
                                                setCurrentAction("addEquipment");
                                                setIsAddDialogOpened(true);
                                              }}
                                            >
                                              Add Equipment
                                            </CustomButtonSmallDarkBg>
                                          </div>
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                          <div className="chip-wrapper">
                                            {theatre?.theatre_equipments?.map((eqp) => (
                                              <Tooltip
                                                title={eqp?.sys_name}
                                                placement="left"
                                              >
                                                <Chip
                                                  key={eqp?._id}
                                                  label={eqp?.equipment_type}
                                                  className="chip"
                                                  onDelete={() => handleRemoveEquipment(theatre?._id, eqp?._id)}
                                                />
                                              </Tooltip>
                                            ))}
                                          </div>
                                        </TableCell>
                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                          <TableCell className="table-cell center" style={{ maxWidth: "60px", }}>
                                            <CircularButton
                                              currentTheme={currentTheme}
                                              onClick={() => {
                                                try {
                                                  if (!["superadmin"].includes(currentUser.user_type_xx)) {
                                                    setNotifyDialogTitle("Note!");
                                                    setNotifyDialogText(`Only Super Admins can remove a theatre!`);
                                                    setIsNotifyDialogOpen(true);
                                                    return;
                                                  }
                                                  const action_text = `Remove ${theatre?.theatre_name} theatre?`;
                                                  setObjectToAction({
                                                    object_id: theatre?._id,
                                                    action_text: action_text,
                                                  });

                                                  setConfirmDialogAction("deleteTheatre");
                                                  setIsConfirmDialogOpen(true);
                                                } catch (error) {
                                                  console.log(error);
                                                }
                                              }}
                                              color="#E53935"
                                              icon={<MdDelete />}
                                              width={"35px"}
                                              height={"35px"} />
                                          </TableCell>}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </div>}


                        {/* PHARMACIES */}
                        {entPharmacies?.length > 0 && <span style={{ marginTop: "10px" }} />}
                        {entPharmacies?.length > 0 && <hr className="separator-h" style={{ marginTop: "10px" }} />}
                        {entPharmacies?.length > 0 && <span style={{ marginTop: "5px" }} />}
                        {entPharmacies?.length > 0 && <span className="sub-title">{entPharmacies?.length === 1 ? `${entPharmacies?.length} PHARMACY` : `${entPharmacies?.length} PHARMACIES`}</span>}
                        {entPharmacies?.length > 0 &&
                          <div className="facility-content">
                            <div className="table-content">
                              <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                  <TableBody className="tablebody">
                                    {entPharmacies?.map((pharma, index) => (
                                      <TableRow
                                        key={pharma._id}
                                        className={`${selectedPharmacy?._id === pharma._id ? "tablerow current" : "tablerow"}`}
                                        onClick={() => {
                                          try {
                                            setSelectedPharmacy(pharma);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      >
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                          {index + 1}
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                          <span className="sub-title">{pharma?.pharmacy_name}</span>
                                        </TableCell>
                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                          <TableCell className="table-cell center" style={{ maxWidth: "60px", }}>
                                            <Tooltip
                                              title={`Delete ${pharma?.pharmacy_name}?`}
                                              placement="right"
                                            >
                                              <CircularButton
                                                currentTheme={currentTheme}
                                                onClick={() => {
                                                  try {
                                                    if (!["superadmin"].includes(currentUser.user_type_xx)) {
                                                      setNotifyDialogTitle("Note!");
                                                      setNotifyDialogText(`Only Super Admins can remove a pharmacy!`);
                                                      setIsNotifyDialogOpen(true);
                                                      return;
                                                    }
                                                    const action_text = `Remove ${pharma?.pharmacy_name} pharmacy?`;
                                                    setObjectToAction({
                                                      object_id: pharma?._id,
                                                      action_text: action_text,
                                                    });

                                                    setConfirmDialogAction("deletePharmacy");
                                                    setIsConfirmDialogOpen(true);
                                                  } catch (error) {
                                                    console.log(error);
                                                  }
                                                }}
                                                color="#E53935"
                                                icon={<MdDelete />}
                                                width={"35px"}
                                                height={"35px"} />
                                            </Tooltip>
                                          </TableCell>}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </div>}
                      </motion.div>
                    </ExpandableComponent>}
                </>}
              {/* GL Setups */}
              {entCode && ["insurance"].includes(currentUser?.token_org_type) &&
                <ExpandableComponent
                  title={t('controlLedgers')}
                  subtitle={
                    documentEnabled === "Y" &&
                    <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                      {/* <label htmlFor="relative_id">MANAGER</label> */}
                      <Select
                        id="ledger_type"
                        name="ledger_type"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="150px"
                        value={selectedLedgerType}
                        onChange={(selectedOption) => setSelectedLedgerType(selectedOption)}
                        options={ledgerTypes}
                        isSearchable={true}
                        placeholder={t('types')}
                      />
                      <AsyncSelect
                        id="mgl_code"
                        name="mgl_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="250px"
                        value={selectedLedger}
                        onChange={(selectedOption) => setSelectedLedger(selectedOption)}
                        loadOptions={(inputValue, callback) => fetchMainLedgers(inputValue, callback, ["Entity"])}
                        isSearchable={true}
                        isDisabled={documentEnabled === "N"}
                        placeholder={t('ledgers')}
                        noOptionsMessage={() => "Type Minimum 1 Letter to Search"} />

                      <CircularButton
                        currentTheme={currentTheme}
                        onClick={async () => {
                          try {
                            if (!selectedLedgerType?.value) {
                              setNotifyDialogTitle("Note!");
                              setNotifyDialogText(`Select type!`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }

                            if (!selectedLedger?.value) {
                              setNotifyDialogTitle("Note!");
                              setNotifyDialogText(`Select ledger!`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }

                            const res = await newRequest.post(
                              "/allEntity/addLedgers",
                              {
                                entity_docid: entityData?._id,
                                ledger_type: selectedLedgerType?.value,
                                ledger_mgl_code: selectedLedger?.value,
                              }
                            );

                            setSelectedLedger(null);
                            setSelectedLedgerType(null);
                            if (res.data?.msg === "added") {
                              setEntLedgers((prev) => [...prev, res.data?.doc]);
                              showToast("Added!", "success");
                            } else if (res.data?.msg === "updated") {
                              const updatedDoc = res.data?.doc;
                              setEntLedgers((prev) => {
                                return prev.map((param) =>
                                  param.ledger_type === updatedDoc.ledger_type ? updatedDoc : param
                                );
                              });
                              showToast("Updated!", "success");
                            } else {
                              showToast("Error adding ledgers!", "error");
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        color="#0ea5a4"
                        icon={<MdAdd />}
                        width={"35px"}
                        height={"35px"} />
                    </div>
                  }
                  defaultExpanded={entLedgers?.length > 0}
                >
                  <div className="ledgers-wrapper">
                    {entLedgers?.length > 0 && (
                      <>
                        {entLedgers?.map((row, index) => (
                          <div key={row._id} className="single-ledger">
                            <span className="type">
                              {index + 1}. {`${row.ledger_type} - ${row.ledger_mgl_code}`}
                            </span>
                            <span className="name">
                              {row.ledger_mgl_code_xx}
                            </span>
                            {documentEnabled === "Y" &&
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                  try {
                                    const action_text = `Remove ${row.ledger_type} - ${row.ledger_mgl_code}?`;
                                    setObjectToAction({
                                      object_id: row.ledger_type,
                                      action_text: action_text,
                                    });
                                    setConfirmDialogAction("removeLedger");
                                    setIsConfirmDialogOpen(true);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                            }
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </ExpandableComponent>}
              {/* START CHARGES */}
              {entCode &&
                entityData?._id !== undefined &&
                (entAentCode.aent_layouts || [])?.find(item => item?.layout_key === "Charges") &&
                <ExpandableComponent
                  title={t('applicableCharges').toUpperCase()}
                  subtitle={
                    documentEnabled === "Y" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#26A69A"
                      endIcon={<MdAdd />}
                      onClick={() => setIsEntityChargeDialogOpen(true)}
                    >
                      {t('addCharge')}
                    </CustomLoadingButton>}
                  defaultExpanded={entityData?.charges_exist_xx === "Y"}
                >
                  <AllEntityCharge documentEnabled={documentEnabled} entityDocid={entityData?._id} ref={entityChargesRef} />
                </ExpandableComponent>}
              {/* END CHARGES */}

              {/* ATTACHMENTS */}
              {entCode &&
                <ExpandableComponent
                  title={t('attachments').toUpperCase()}
                  subtitle={entityFilesData.length === 1 ? `1 ${t('attachment').toUpperCase()}` : `${entityFilesData.length} ${t('attachments').toUpperCase()}`}
                  defaultExpanded={false}
                >
                  <motion.div
                    className="attachments-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <FileUploadComponent
                      documentNo={entCode}
                      documentId={entityId}
                      documentType="All Entity"
                      fetchDocumentAttachments={() => fetchEntityFiles(entityId)}
                      uploadFolder={`all-entity/${entityId}`}
                    />
                    <AllFiles filesList={entityFilesData} whatsappAllowed={entWhatsapp} phoneNo={entWhatsappNo} />
                  </motion.div>
                </ExpandableComponent>}
              {entCode &&
                (entAentCode.aent_layouts || [])?.find(item => item?.layout_key === "Ratings") &&
                <ExpandableComponent
                  title={t('ratings').toUpperCase()}
                  subtitle={
                    documentEnabled === "Y" &&
                    <CircularButton
                      currentTheme={currentTheme}
                      onClick={async (e) => {
                        try {
                          const newRecord = {
                            _id: generateUniqueCode(),
                            rate: "",
                            grade: "",
                            meaning: "",
                            flag_xx: "new",
                          }
                          // console.log(`newRecord  ${JSON.stringify(newRecord, null, 2)}`);
                          setEntRatings((prevData) => [...prevData, newRecord]);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      color="#0ea5a4"
                      icon={<MdAdd />}
                      width={"35px"}
                      height={"35px"} />}
                  defaultExpanded={entRatings?.length > 0}
                >
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                              <span>{t('rate').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                              <span>{`${t('grade').toUpperCase()}`}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{`${t('meaning').toUpperCase()}`}</span>
                            </TableCell>
                            {documentEnabled === "Y" &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{`${t('action').toUpperCase()}`}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {paginatedRatings?.map((row, index) => (
                            <TableRow
                              key={index}
                              className={`${selectedRating?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedRating(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {currentPageRatings * rowsPerPageRatings + index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`rate_${row?._id}`}
                                      name={`rate_${row?._id}`}
                                      type="text"
                                      value={row?.rate}
                                      onChange={(e) => handleRatingsChange(e, row?._id, 'rate')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                  :
                                  <span className="sub-title">{row?.rate}</span>}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`grade_${row?._id}`}
                                      name={`grade_${row?._id}`}
                                      type="text"
                                      value={row?.grade}
                                      onChange={(e) => handleRatingsChange(e, row?._id, 'grade')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                  :
                                  <span className="sub-title">{row?.grade}</span>}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                {documentEnabled === "Y" ?
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`meaning_${row?._id}`}
                                      name={`meaning_${row?._id}`}
                                      type="text"
                                      value={row?.meaning}
                                      onChange={(e) => handleRatingsChange(e, row?._id, 'meaning')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                  :
                                  <span className="sub-title">{row?.meaning}</span>}
                              </TableCell>
                              {documentEnabled === "Y" &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async (e) => {
                                      try {
                                        // const res = await newRequest.post("/fund/removeAssetClass",
                                        //   {
                                        //     fund_docid: fundDocId,
                                        //     asset_class: row?.asset_class
                                        //   });

                                        // if (res.data?.msg === "removed") {
                                        //   setAssetAllocation((prevData) =>
                                        //     prevData.filter(doc => doc?.asset_class !== row?.asset_class)
                                        //   );

                                        //   showToast("Deleted!", "success");
                                        // } else {
                                        //   showToast("Error deleting report!", "error");
                                        // }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"35px"}
                                    height={"35px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {entRatings?.length > rowsPerPageRatings &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPageRatings}
                          onRowsPerPageChange={handleRowsPerPageRatings}
                          component="div"
                          count={entRatings?.length}
                          rows={entRatings}
                          page={currentPageRatings}
                          onPageChange={handlePageChangeRating}
                        />}
                    </TableContainer>
                  </div>
                </ExpandableComponent>}
              {/* end of ratings */}

            </div>
          </div>
          <div className="right-wrapper">
            <div className="logo">
              {entPhotoUrl ?
                <img src={entPhotoUrl} alt="" className="logo" />
                :
                <InitialsAvatar
                  name={entName}
                  size={120}
                  currentTheme={currentTheme}
                />}
              <input
                type="file"
                id="file"
                style={{ display: "none" }}
                accept="image/*"
                onChange={(e) => setImg(e.target.files[0])}
              />
              {entStatus?.value !== "Closed" &&
                <label htmlFor="file" style={{ cursor: "pointer" }}>
                  <h1 className="sub-title">{entPhotoUrl ? t('changeLogo') : t('selectLogo')}</h1>
                </label>}
            </div>
            <div className="right-content">
              <h1 className="sub-title">{t('timeline').toUpperCase()}</h1>
              <div className="timeline-root">
                {entityTraceData.map((item) => (
                  <div key={item?._id} className="timeline-item">
                    <div className="timeline-separator">
                      <div className="timeline-dot"></div>
                      <div className="timeline-connector" />
                    </div>
                    <div className="timeline-content">
                      <div className="timeline-navbar">
                        <div className="avatar-container">
                          {item?.updated_by_photo_url_xx ?
                            <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" />
                            :
                            <InitialsAvatar
                              name={item?.updated_by_name_xx}
                              size={30}
                              currentTheme={currentTheme}
                            />
                          }
                          <span className="username">{item?.updated_by_name_xx}</span>
                        </div>
                        <span className="time-ago">{item?.time_ago_xx}</span>
                      </div>
                      <div className="remarks">
                        {item?.trc_remarks}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className="worked-on-by">
                <WorkedOnBy name={entityData?.updated_by_name_xx} photoUrl={entityData?.updated_by_photo_url_xx} time_ago_xx={entityData?.time_ago_xx} />
              </div> */}
            </div>
          </div>
        </div>
      )}
      {/* progress dialog for file upload  */}
      <UploadDialog
        open={isDialogOpen}
        handleClose={() => setIsDialogOpen(false)}
        uploadProgress={uploadProgress}
      />
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: sanitizeText(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>

      {/* <NotifyDialog
        open={isNotifyDialogOpen}
        title={notifyDialogTitle}
        text={notifyDialogText}
        onClose={() => setIsNotifyDialogOpen(false)}
      /> */}

      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {placesDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('place')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setPlacesDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <GooglePlacesSelect onPlaceSelect={handlePlaceSelect} />
              {selectedPlace && (
                <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "10px" }}>
                  <hr className='separator-h' />
                  <span className='sub-title'>{`${t('place')} : ${selectedPlace.label}`}</span>
                  <span className='sub-title'>{`${t('latitude')} : ${selectedPlace.coordinates.lat}`}</span>
                  <span className='sub-title'>{`${t('longitude')} : ${selectedPlace.coordinates.lng}`}</span>
                </div>
              )}
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                borderRadiusType="both"
                variant="tint"
                color="#1976D2"
                tooltip={`${t('select')} ${selectedPlace?.label}`}
                iconPosition="start"
                startIcon={<RiMapPin5Fill />}
                onClick={() => {
                  try {
                    setEntLatitude(selectedPlace?.coordinates.lat);
                    setEntLongitude(selectedPlace?.coordinates.lng);
                    setEntPlaceName(selectedPlace?.label);
                    setPlacesDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                disabled={!selectedPlace}
              >
                {t('select').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>)}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={entityData?.report_keys_array}
                documentData={{
                  docNo: entCode,
                  docType: "Entity",
                  docId: entityId,
                  clientEmail: entEmail,
                  clientEntCode: entCode,
                  clientEntName: entName
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isAddDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{isAddDialogTitle}</h1>
              <CircularButton currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setNewCode(null);
                    setNewName(null);
                    setNewType(null);
                    setNewBeds(0);
                    setIsAddDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            {currentAction === "addEquipment"
              ? <div className="overlay-content" style={{ width: "500px" }}>
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", maxWidth: "450px" }}>
                            <div className="search-input-wrapper" style={{ width: "100%" }}>
                              <FiSearch className="search-input-icon" />
                              <input
                                className="search-input"
                                type="text"
                                placeholder="Search..."
                                value={searchTermEquipment}
                                onChange={(e) => setSearchTermEquipment(e.target.value)}
                              />
                              {searchTermEquipment.length > 0 && (
                                <IoClose
                                  onClick={() => setSearchTermEquipment("")}
                                  className="search-input-icon"
                                />
                              )}
                            </div>
                          </TableCell>
                          {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              ADD
                            </TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {slicedEquipments
                          ?.filter(
                            (eqp) =>
                              eqp.sys_name.toLowerCase().includes(searchTermEquipment.toLowerCase())
                          )
                          .map((eqp, index) => (
                            <TableRow
                              key={eqp._id}
                              className={`${selectedEquipment?._id === eqp?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => {
                                try {
                                  setSelectedEquipment(eqp);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {currentEquipmentPage * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", maxWidth: "450px" }}>
                                <span style={{ width: "100%" }}>{eqp?.sys_name}</span>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                  <CircularButton currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {

                                        setIsProcessing(true);
                                        const res = await newRequest.post(
                                          "/allEntity/addFacilityDetails",
                                          {
                                            ent_docid: entityData._id,
                                            theatre_docid: selectedTheatre?._id,
                                            current_action: "addTheatreEquipment",
                                            equipment_type: eqp?.sys_code,
                                            equipment_desc: eqp?.sys_desc
                                          }
                                        );
                                        setIsProcessing(false);
                                        // console.log(`reponse ${JSON.stringify(res.data, null, 2)}`);
                                        if (res.data?.msg === "added") {
                                          setEntFacilityTheatres(prevTheatres =>
                                            prevTheatres.map(theatre => {
                                              if (theatre._id === selectedTheatre?._id) {
                                                return {
                                                  ...theatre,
                                                  theatre_equipments: [...theatre.theatre_equipments, res.data?.doc]
                                                };
                                              }
                                              return theatre;
                                            })
                                          );
                                          showToast("Added!", "success");
                                        } else {
                                          showToast("Error adding relationship!", "error");
                                        }

                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }} icon={<RiCheckFill />} width={"35px"} height={"35px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleEquipmentsRowsPerPage}
                      component="div"
                      count={equipments?.length}
                      rows={equipments}
                      page={currentEquipmentPage}
                      onPageChange={handleEquipmentsPageChange}
                    />
                  </TableContainer>
                </div>
              </div> :
              <div className="overlay-content">
                {["addWard"].includes(currentAction) &&
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newCode"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('no').toUpperCase()}
                    </label>
                    <input
                      id="newCode"
                      name="newCode"
                      type="text"
                      placeholder="NO"
                      value={newCode}
                      className="form-input-item"
                      style={{ width: "100px" }}
                      onChange={(e) => setNewCode(e.target.value)}
                    />
                  </div>}
                {["addWard", "addTheatre"].includes(currentAction)
                  && <div className="input-item-with-label">
                    <label
                      htmlFor="newName"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      NAME
                    </label>
                    <input
                      id="newName"
                      name="newName"
                      type="text"
                      placeholder="NAME"
                      value={newName}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      onChange={(e) => setNewName(e.target.value)}
                    />
                  </div>}

                {["addPlan"].includes(currentAction) &&
                  <div className="input-item-with-label">
                    <label htmlFor="plan_type"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}>
                      PLAN
                    </label>
                    <Select
                      id="plan_type"
                      name="plan_type"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={selectedAvailablePlan}
                      onChange={(selectedOption) => {
                        try {
                          setSelectedAvailablePlan(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={availablePlans}
                      isSearchable={true}
                      placeholder="Plan"
                    />
                  </div>}

                {["addTheatre"].includes(currentAction) &&
                  <div className="input-item-with-label">
                    <label htmlFor="theatre_type"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}>
                      TYPE
                    </label>
                    <Select
                      id="theatre_type"
                      name="theatre_type"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={newType}
                      onChange={(selectedOption) => {
                        try {
                          setNewType(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={theatreTypes}
                      isSearchable={true}
                      placeholder="Type"
                    />
                  </div>}
                {["addWard"].includes(currentAction) &&
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newBeds"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      NO Of BEDS
                    </label>
                    <input
                      id="newBeds"
                      name="newBeds"
                      type="text"
                      placeholder="NO"
                      value={newBeds}
                      className="form-input-item"
                      style={{ width: "100px" }}
                      onChange={(e) => setNewBeds(e.target.value)}
                    />
                  </div>}
              </div>}
            {currentAction !== "addEquipment" &&
              <div className="overlay-actions">
                <CustomLoadingButton currentTheme={currentTheme} onClick={handleNewAction}>
                  {t('add').toUpperCase()}
                </CustomLoadingButton >
              </div>}
          </div>
        </motion.div>
      )}
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-content">
              <ValidationMessages
                messageData={validationMessagesResult}
                onClose={() => setValidationMsgDialog(false)}
                onFix={(row) => {/* focus field / navigate */ }}
                onRemind={() => setValidationMsgDialog(false)}
                onSupport={() => navigate("/support")}
              />
            </div>
          </div>
        </motion.div>
      )}
      {isEntityChargeDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title"> {t('addCharge')} </h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setIsEntityChargeDialogOpen(false)}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="selectedCharge"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('charge').toUpperCase()}
                </label>
                <Select
                  id="selectedCharge"
                  name="selectedCharge"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="300px"
                  value={selectedCharge}
                  onChange={(selectedOption) => setSelectedCharge(selectedOption)}
                  options={definedCharges}
                  isSearchable={true}
                  placeholder={t('select').toUpperCase()}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#00D37F"
                tooltip={`${t('add')} ${selectedCharge?.label}`}
                endIcon={<MdAdd />}
                onClick={async () => {
                  try {
                    if (!selectedCharge) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(`Please select charge!`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }
                    const res = await newRequest.post("/allEntityCharge/add", {
                      ac_ent_docid: entityData?._id,
                      ac_ent_code: entityData?.ent_code,
                      ac_charge_code: selectedCharge?.value,
                      ac_charge_name: selectedCharge?.label
                    });
                    if (res.data.msg === "added") {
                      await entityChargesRef.current?.refreshCharges();
                      setSelectedCharge(null);
                      showToast(t('added'), "success");
                    } else if (res.data.msg === "exists") {
                      showToast(`Charge ${selectedCharge?.label} already exists`, "error");
                    } else {
                      showToast("Error adding charge!", "error");
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                {t('add')}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};


const BedCard = ({ bed, currentTheme }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const StyledMenu = styled(Menu)(({ theme }) => ({
    "& .MuiPaper-root": {
      backgroundColor: "#333", // Background color of the menu
      color: "#fff", // Font color
      borderRadius: "8px",
    },
  }));

  const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    "&:hover": {
      backgroundColor: "#555", // Hover background color
    },
  }));

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`bed-card ${bed?.bed_occupied === "Y" ? "occupied" : "normal"}`}>
      <div className="bed-header">
        <p>{`#: ${bed?.bed_no}`}</p>
        <CircularButton className="menu-icon" currentTheme={currentTheme} onClick={handleMenuOpen} icon={<RiMenu5Line />} width={"35px"} height={"35px"} />
        {/* <IconButton onClick={handleMenuOpen} className="menu-icon">
          <RiMenu5Line />
        </IconButton> */}
      </div>
      <p>{`Occupied: ${bed?.bed_occupied}`}</p>
      {/* Dropdown Menu */}
      <StyledMenu anchorEl={anchorEl} open={open} onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left", // Menu is anchored to the right of the icon
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right", // Menu appears to the left of the icon
        }}>
        <StyledMenuItem onClick={() => console.log("Edit")}>Edit</StyledMenuItem>
        <StyledMenuItem onClick={() => console.log("Move")}>Move</StyledMenuItem>
        <StyledMenuItem onClick={() => console.log("Delete")}>Delete</StyledMenuItem>
        <StyledMenuItem onClick={() => console.log("More Options")}>History</StyledMenuItem>
        <StyledMenuItem onClick={() => console.log("More Options")}>More</StyledMenuItem>
      </StyledMenu>
    </div>
  );
};


export default AllEntity;
